var Y = Object.defineProperty;
var tt = (i, e, t) => e in i ? Y(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t;
var h = (i, e, t) => tt(i, typeof e != "symbol" ? e + "" : e, t);
class et {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  ssoMode(e) {
    const t = {
      method: "GET",
      path: `organization/${e}/ssoMode`,
      useAuth: !0,
      useContext: !1
    };
    return this.client.doRequest(t);
  }
  ssoModeByContext(e) {
    const t = {
      method: "GET",
      path: `organization/${e}/ssoMode`,
      useAuth: !0,
      useContext: !1
    };
    return this.client.doRequest(t);
  }
  inviteUsers(e, t, s, o) {
    const n = {
      method: "POST",
      path: "/invite-users",
      body: {
        invites: e,
        language: t,
        message: s
      },
      context: o,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(n);
  }
}
class st {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  createComment(e, t, s) {
    const o = {
      method: "POST",
      path: `/comments/${e}/comment/${t}`,
      body: s,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  adminUpdateComment(e, t, s, o) {
    const n = {
      method: "PUT",
      path: `/admin/comments/${e}/comment/${t}`,
      params: {
        targetType: o
      },
      body: s,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(n);
  }
  updateOwnComment(e, t, s) {
    const o = {
      method: "PUT",
      path: `/comments/${e}/comment/${t}`,
      body: s,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  adminDeleteComment(e, t, s) {
    const o = {
      method: "DELETE",
      path: `/admin/comments/${e}/comment/${t}`,
      params: {
        targetType: s
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  deleteOwnComment(e, t) {
    const s = {
      method: "DELETE",
      path: `/comments/${e}/comment/${t}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  fetchCommentById(e, t) {
    const s = {
      method: "GET",
      path: `/comments/${e}/comment/${t}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  fetchCommentsForTarget(e, t = !1, s = !1) {
    const o = {
      method: "GET",
      path: `/comments/${e}/comments`,
      params: {
        includeThread: t,
        includeReactions: s
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
}
class ot {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  createComment(e, t, s) {
    const o = {
      method: "POST",
      path: `/private-comments/${e}/${t}`,
      body: s,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  adminUpdateComment(e, t, s, o) {
    const n = {
      method: "PUT",
      path: `/private-comments/${e}/${t}`,
      body: s,
      params: {
        targetType: o
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(n);
  }
  adminUpdateOwnComment(e, t, s, o) {
    const n = {
      method: "PUT",
      path: `/private-comments/${e}/${t}/own`,
      body: s,
      params: {
        targetType: o
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(n);
  }
  deleteOwnComment(e, t, s) {
    const o = {
      method: "DELETE",
      path: `/private-comments/${e}/${t}/own`,
      params: {
        targetType: s
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  deleteComment(e, t, s) {
    const o = {
      method: "DELETE",
      path: `/private-comments/${e}/${t}`,
      params: {
        targetType: s
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  fetchCommentsForTarget(e, t, s = !1, o = !1) {
    const n = {
      method: "GET",
      path: `/private-comments/${e}`,
      params: {
        includeThread: s,
        includeReactions: o,
        targetType: t
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(n);
  }
}
class nt {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  async fetchDynamicTypes(e, t) {
    const s = {
      method: "GET",
      path: `/dynamic-fields/${e}`,
      useContext: !0,
      useAuth: !0,
      context: t
    };
    return this.client.doRequest(s);
  }
  async fetchDynamicData(e, t = "") {
    const s = new URL(e);
    let o = new URLSearchParams(s.search);
    o.append("searchText", t);
    const r = {
      path: "",
      method: "GET",
      url: `${s.origin}${s.pathname}?${o.toString()}`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(r);
  }
  async callCustomUrl(e, t, s, o) {
    const n = {
      path: "",
      method: t,
      url: e,
      params: o,
      body: s,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(n);
  }
  async updateDynamicFieldConfiguration(e, t) {
    const s = {
      method: "PUT",
      path: "/admin/dynamic-fields",
      body: t,
      useContext: !0,
      useAuth: !0,
      context: e
    };
    return this.client.doRequest(s);
  }
}
class rt {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  async fetchDynamicInfoManagement(e, t) {
    const s = {
      method: "GET",
      path: `/dynamic-info-management/${e}`,
      params: {
        size: t
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
}
class at {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  send(e) {
    const t = {
      method: "POST",
      path: "/email/send",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
}
class it {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  sendEvent(e, t, s) {
    const o = {
      method: "POST",
      path: "/event",
      body: e,
      useContext: !0,
      useAuth: !0,
      context: t
    };
    return s && (o.headers = { product: s }), this.client.doRequest(o);
  }
}
var ct = /* @__PURE__ */ ((i) => (i.create = "create", i.change = "change", i.add = "add", i.remove = "remove", i.register = "register", i.set_admin = "set_admin", i.set_profile = "set_profile", i.subscribe = "subscribe", i.unsubscribe = "unsubscribe", i.relationship = "relationship", i.login_throttled = "login_throttled", i.login = "login", i.set_mfa_failed = "set_mfa_failed", i.set_mfa = "set_mfa", i.forgot_password = "forgot_password", i.set_password = "set_password", i.load = "load", i.click = "click", i))(ct || {});
class ut {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  fetchActivityFeed(e, t) {
    const s = {
      method: "GET",
      path: `/activity-feed/${e}`,
      params: { ...t },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  fetchTopReactors(e, t) {
    const s = {
      method: "GET",
      path: `/activity-feed/${e}/top-reactors`,
      params: { ...t },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  fetchTopCommenters(e, t) {
    const s = {
      method: "GET",
      path: `/activity-feed/${e}/top-commenters`,
      params: { ...t },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  // OLD ACTIVITY FEED
  fetchCreatedTickets(e, t) {
    const s = {
      method: "GET",
      path: `/activity-feed/${e}/created-tickets`,
      params: { ...t },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  fetchPopularTickets(e, t) {
    const s = {
      method: "GET",
      path: `/activity-feed/${e}/popular-tickets`,
      params: { ...t },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  fetchPopularTopics(e, t) {
    const s = {
      method: "GET",
      path: `/activity-feed/${e}/topics`,
      params: { ...t },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  fetchMostActiveUsers(e, t) {
    const s = {
      method: "GET",
      path: `/activity-feed/${e}/most-active-users`,
      params: { ...t },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
}
class ht {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  uploadFile(e, t, s) {
    const o = new FormData(), n = e.type.split("/")[1];
    o.append("file", e, `randomName.${n}`), o.append("prefix", t), o.append("tags", ""), s && o.append("contentDisposition", `attachment; filename="${s}"`);
    const r = {
      method: "POST",
      content: "form",
      path: "/fileUpload",
      body: o,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(r);
  }
}
class dt {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  start(e, t, s) {
    const o = {
      method: "POST",
      path: `${e}/fileUpload/${t}/start`,
      body: s,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  getSignedUrl(e, t) {
    const s = {
      method: "POST",
      path: `${e}/fileUpload/multiUpload/getSignedUrl`,
      body: t,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  stop(e, t, s) {
    const o = {
      method: "POST",
      path: `${e}/fileUpload/${t}/stop`,
      body: s,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  remove(e, t, s) {
    const o = {
      method: "DELETE",
      path: `${e}/fileUpload/${t}/${s}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
}
class lt {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  fetchIndexKeywords(e) {
    const t = {
      method: "GET",
      path: `/global-search/keywords/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  ticketSearch(e) {
    const t = {
      method: "POST",
      path: "/global-search/ticket",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  ticketAttachmentSearch(e) {
    const t = {
      method: "POST",
      path: "/global-search/ticket-attachment",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  userSearch(e) {
    const t = {
      method: "POST",
      path: "/global-search/users",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  quickSearch(e) {
    const t = {
      method: "POST",
      path: "/global-search/quick-search",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
}
class pt {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  fetchAvailableOffers(e) {
    const t = {
      method: "GET",
      path: "/juoco/availableOffers",
      params: {
        group: e
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  getOfferById(e) {
    const t = {
      method: "GET",
      path: `/juoco/offer/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  getTicketWallets(e) {
    const t = {
      method: "GET",
      path: `/juoco/${e.product}/getTicketWithWallets`,
      params: {
        status: e.status
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  fetchTicketWallet(e) {
    const t = {
      method: "GET",
      path: "/juoco/wallet/ticket",
      params: {
        ticketId: e
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  fetchCompanyWallet(e) {
    const t = {
      method: "GET",
      path: "/juoco/wallet/company",
      params: {
        companyId: e
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  fetchWalletOwners(e) {
    const t = {
      method: "POST",
      path: "/juoco/wallet-owner/batch",
      body: {
        targets: e
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  fetchTicketWalletByBatch(e) {
    const t = {
      method: "POST",
      path: "/juoco/wallet/ticket/batch",
      body: {
        ticketIds: e
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  transferFunds(e) {
    const t = {
      method: "POST",
      path: "/juoco/transfer",
      body: {
        fromWalletId: e.fromWalletId,
        toWalletId: e.toWalletId,
        value: e.value,
        meta: {
          description: e.description
        }
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  getTicketTransactions(e) {
    const t = {
      method: "GET",
      path: `/juoco/transaction/ticket/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  getOrganizationTransactions(e) {
    const t = {
      method: "GET",
      path: `/juoco/transaction/organization/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  getMetaOrganizationWallets(e) {
    const t = {
      method: "GET",
      path: `/meta/${e}/juoco/wallet`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  getMetaOrganizationTransactionsAllWallet(e) {
    const t = {
      method: "GET",
      path: `/meta/${e}/juoco/transaction`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  getMetaOrganizationTransactionsByWallet(e, t) {
    const s = {
      method: "GET",
      path: `/meta/${e}/juoco/transaction/organization/${t}`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  getMetaOrganizationTransactionById(e, t) {
    const s = {
      method: "GET",
      path: `/meta/${e}/juoco/transaction/details/${t}`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  getMetaOrganizationWalletsDetailsBatch(e, t) {
    const s = {
      method: "POST",
      path: `/meta/${e}/juoco/wallets/details/batch`,
      body: {
        context: e,
        targets: t
      },
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  getAdminOrganizationWallets() {
    const e = {
      method: "GET",
      path: "/juoco/wallet",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  getAdminOrganizationTransactionsAllWallet() {
    const e = {
      method: "GET",
      path: "/juoco/transaction",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  getAdminOrganizationTransactionsByWallet(e) {
    const t = {
      method: "GET",
      path: `/juoco/transaction/organization/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  getAdminOrganizationTransactionById(e) {
    const t = {
      method: "GET",
      path: `/juoco/transaction/details/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  getAdminOrganizationWalletsDetailsBatch(e) {
    const t = {
      method: "POST",
      path: "/juoco/wallets/details/batch",
      body: {
        targets: e
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  createOfferRequest(e) {
    const t = {
      method: "POST",
      path: `/juoco/requestOffer/${e.offerId}`,
      params: {
        ticketId: e.ticketId,
        amount: e.quantity
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  createAdminOfferRequest(e) {
    const t = {
      method: "POST",
      path: `/juoco/admin/requestOffer/${e.offerId}`,
      params: {
        comment: e.comment,
        amount: e.quantity,
        workgroupId: e.workgroupId
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  contextWalletTopUp(e, t) {
    const s = {
      method: "POST",
      path: `meta/${e}/juoco/wallet/topUpContextWallet`,
      params: t,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  contextWalletBurnCredits(e, t) {
    const s = {
      method: "POST",
      path: `meta/${e}/juoco/wallet/burnCreditContextWallet`,
      params: t,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  fetchServiceOrdersByContext() {
    const e = {
      method: "GET",
      path: "/juoco/getServiceOrderTicketsByContext",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  fetchContextServiceOrders() {
    const e = {
      method: "GET",
      path: "/juoco/getOfferContextServiceOrderTickets",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  // Gamification 2.0 stuff...
  getVirtualGoodsFromPlayer(e, t, s) {
    const o = {
      method: "GET",
      path: `juoco/player/${e}`,
      params: {
        virtualGoodType: t,
        playerType: s
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  getAvailableChallenges() {
    const e = {
      method: "GET",
      path: "juoco/own/challenges/available",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  getJoinedChallenges() {
    const e = {
      method: "GET",
      path: "juoco/own/challenges/joined",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  getBadges(e) {
    const t = {
      method: "GET",
      path: `juoco/userBadge/player/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  adminFetchChallenges() {
    const e = {
      method: "GET",
      path: "/juoco/challenge",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  adminFetchChallengeById(e) {
    const t = {
      method: "GET",
      path: `/juoco/challenge/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  adminUpdateChallenge(e, t) {
    const s = {
      method: "PUT",
      path: `/juoco/updateChallenge/${e}`,
      body: t,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  adminCreateChallenge(e) {
    const t = {
      method: "POST",
      path: "/juoco/createChallenge",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  bulkPurchaseOffer(e) {
    const t = {
      method: "POST",
      path: "juoco/admin/bulkPurchase",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  metaFetchChallengesByContext(e) {
    const t = {
      method: "GET",
      path: `/meta/${e}/juoco/all-challenges`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  metaFetchUpdatableChallengeById(e, t) {
    const s = {
      method: "GET",
      path: `/meta/${e}/juoco/challenge/updatable/${t}`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  metaUpdateChallenge(e, t, s) {
    const o = {
      method: "PUT",
      path: `/meta/${e}/juoco/challenge/${t}`,
      body: s,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  metaCreateChallenge(e, t) {
    const s = {
      method: "POST",
      path: `/meta/${e}/juoco/challenge`,
      body: t,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
}
var mt = /* @__PURE__ */ ((i) => (i.CREDIT = "CREDIT", i.DEBIT = "DEBIT", i))(mt || {});
class ft {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  async getAvailableClasses() {
    const e = {
      method: "GET",
      path: "links/availableClasses",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  async getAvailableRelations() {
    const e = {
      method: "GET",
      path: "links/availableRelations",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  async getTicketLinks(e) {
    return this.getLinkByClass("TICKET", e);
  }
  async getLinkByClass(e, t) {
    const s = {
      method: "GET",
      path: `links/${e}/${t}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  async addLink(e) {
    const t = {
      method: "POST",
      path: "links",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  async deleteLink(e) {
    const t = {
      method: "DELETE",
      path: "links",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
}
class gt {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  getMessages() {
    const e = {
      method: "GET",
      path: "/notification/message/user",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  deleteMessage(e) {
    const t = {
      method: "DELETE",
      path: `/notification/message/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  markAsRead(e) {
    const t = {
      method: "PATCH",
      path: `/notification/message/${e}/read`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  markAsReadBatch(e, t) {
    const s = {
      method: "POST",
      path: "/notification/message/read/batch",
      body: {
        context: t,
        targets: e
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  markAsDelivered(e) {
    const t = {
      method: "PATCH",
      path: `/notification/message/${e}/delivery`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  markAsDeliveredBatch(e, t) {
    const s = {
      method: "POST",
      path: "/notification/message/delivery/batch",
      body: {
        context: t,
        targets: e
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
}
var Tt = /* @__PURE__ */ ((i) => (i.BASIC = "application/vnd.ileti+json", i.REVIEW = "application/vnd.rready.message.review+json", i.MODAL = "application/vnd.rready.message.modal+json", i))(Tt || {});
class yt {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  fetchCurrentOrganization(e) {
    const t = {
      method: "GET",
      path: "/organization/current",
      useContext: !0,
      context: e,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  updateOrganization(e, t) {
    const s = {
      method: "PUT",
      path: `/organization/${e}`,
      body: t,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  fetchSsoSettings() {
    const e = {
      method: "GET",
      path: "/organization/ssoSettings",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  updateSsoSettings(e) {
    const t = {
      method: "POST",
      path: "/organization/ssoSettings",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  customKeys() {
    const e = {
      method: "POST",
      path: "/organization/ssoSettings/customKeys",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  clearCustomKeys() {
    const e = {
      method: "POST",
      path: "/organization/ssoSettings/clearCustomKeys",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  fetchAllOrganizations(e) {
    const t = {
      method: "GET",
      path: "/organization",
      params: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  metaFetchOrganizationByContext(e) {
    const t = {
      method: "GET",
      path: `/meta/organization/${e}`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  metaFetchAllOrganizations(e) {
    const t = {
      method: "GET",
      path: "/meta/organization",
      params: e,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  metaCreateOrganization(e) {
    const t = {
      method: "POST",
      path: "/meta/organization",
      body: e,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  metaCreateOrganizationTrial(e) {
    const t = {
      method: "POST",
      path: "/meta/organization/trial",
      body: e,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  metaRemoveOrganizationTrial(e, t) {
    const s = {
      method: "PUT",
      path: `/meta/organization/${e}/removeTrial`,
      body: t,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  metaDeleteOrganization(e) {
    const t = {
      method: "DELETE",
      path: `/meta/organization/${e}`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  metaDisableOrganization(e) {
    const t = {
      method: "PUT",
      path: `/meta/organization/${e}/disable`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  metaEnableOrganization(e) {
    const t = {
      method: "PUT",
      path: `/meta/organization/${e}/enable`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  metaToggleDefaultFeedback(e, t, s) {
    const o = {
      method: "PUT",
      path: `/meta/organization/${e}/${t}/toggleDefaultFeedback?enabled=${s}`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
}
class Ct {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  createReaction(e, t, s) {
    const o = {
      method: "POST",
      path: `/quetal/reactions/${e}/reaction/${t}/${s}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  deleteReaction(e, t, s) {
    const o = {
      method: "DELETE",
      path: `/quetal/reactions/${e}/reaction/${t}/${s}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  fetchReactions(e) {
    const t = {
      method: "GET",
      path: `/quetal/reactions/${e}/reaction`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  fetchReactionBoard(e, t = !0, s = !0, o = !1) {
    const n = {
      method: "POST",
      path: "/quetal/reaction-board/ticket",
      body: {
        targets: e
      },
      params: {
        comments: t,
        reactions: s,
        tags: o
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(n);
  }
}
class At {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  fetchActions(e) {
    const t = {
      method: "GET",
      path: "/actions",
      useContext: !0,
      useAuth: !0,
      context: e
    };
    return this.client.doRequest(t);
  }
  fetchAllActions() {
    const e = {
      method: "GET",
      path: "/actions/fetchAll",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  fetchRolesAndActions(e, t) {
    const s = {
      method: "GET",
      path: `/actions/fetchRoles/${e}`,
      useContext: !0,
      useAuth: !0,
      context: t
    };
    return this.client.doRequest(s);
  }
  metaFetchRolesByUser(e, t) {
    const s = {
      method: "GET",
      path: `/meta/${e}/fetchRoles/${t}`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  fetchAllRoles() {
    const e = {
      method: "GET",
      path: "/roles/all",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  adminFetchAllRoles() {
    const e = {
      method: "GET",
      path: "admin/roles/all",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  metaFetchAllRolesByContext(e) {
    const t = {
      method: "GET",
      path: `/meta/${e}/roles`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  metaFetchRoleActionsByContext(e, t) {
    const s = {
      method: "GET",
      path: `/meta/${e}/${t}/actions`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  metaCreateRoleActionsByContext(e, t, s) {
    const o = {
      method: "POST",
      path: `/meta/${e}/${t}/actions`,
      body: s,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  metaUpdateRoleActionsByContext(e, t, s) {
    const o = {
      method: "POST",
      path: `/meta/${e}/${t}/actions`,
      body: s,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  metaDeleteRoleActionsByContext(e, t, s) {
    const o = {
      method: "DELETE",
      path: `/meta/${e}/${t}/actions`,
      body: s,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  metaDeleteRoleByContext(e, t, s = !1) {
    const o = {
      method: "DELETE",
      path: `/meta/${e}/${t}`,
      params: { force: s },
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  adminUpdateRoleActions(e, t) {
    const s = {
      method: "POST",
      path: `/admin/${e}/actions`,
      body: t,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  adminDeleteRoleActions(e, t) {
    const s = {
      method: "DELETE",
      path: `/admin/${e}/actions`,
      body: t,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  adminDeleteRole(e, t = !1) {
    const s = {
      method: "DELETE",
      path: `/admin/roles/${e}`,
      params: { force: t },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
}
class wt {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  save(e, t, s, o, n) {
    const r = `/${t}/digital-content/gallery/${s}/section/${o}/item`, u = {
      method: "POST",
      path: n ? `${r}/${n}` : r,
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(u);
  }
  delete(e, t, s, o) {
    const n = {
      method: "DELETE",
      path: `/${e}/digital-content/gallery/${t}/section/${s}/item/${o}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(n);
  }
  fetchById(e, t, s, o) {
    const n = {
      method: "GET",
      path: `/${e}/digital-content/gallery/${t}/section/${s}/item/${o}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(n);
  }
  fetchGallery(e, t, s) {
    const o = {
      method: "GET",
      path: `/${e}/digital-content/gallery/${t}/section`,
      params: {
        ...s
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  fetchSectionItems(e, t, s, o) {
    const n = {
      method: "GET",
      path: `/${e}/digital-content/gallery/${t}/section/${s}/item`,
      params: {
        ...o
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(n);
  }
  addTagToSectionItem(e, t, s, o, n) {
    const r = {
      method: "GET",
      path: `/${e}/digital-content/gallery/${t}/section/${s}/item/${o}/tag/${n}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(r);
  }
  // --- meta ---
  metaFetchDigitalContent(e, t, s) {
    const o = {
      method: "GET",
      path: `/meta/${e}/digital-content/${t}`,
      params: {
        ...s
      },
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  metaFetchSections(e, t, s, o) {
    const n = {
      method: "GET",
      path: `/meta/${e}/digital-content/${t}/gallery/${s}/section`,
      params: {
        ...o
      },
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(n);
  }
  metaFetchSectionItemById(e, t, s, o, n) {
    const r = {
      method: "GET",
      path: `/meta/${e}/digital-content/${t}/gallery/${s}/section/${o}/item/${n}`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(r);
  }
  metaSaveGallery(e, t, s) {
    const o = {
      method: "POST",
      path: `/meta/${e}/digital-content/${t}/gallery/${s}`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  metaSavesSectionItem(e, t, s, o, n, r) {
    const a = `/meta/${t}/digital-content/${s}/gallery/${o}/section/${n}/item`, c = {
      method: "POST",
      path: r ? `${a}/${r}` : a,
      body: e,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(c);
  }
  metaDeleteSectionItem(e, t, s, o, n) {
    const r = {
      method: "DELETE",
      path: `/meta/${e}/digital-content/${t}/gallery/${s}/section/${o}/item/${n}`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(r);
  }
  metaAddTagToSectionItem(e, t, s, o, n, r) {
    const a = {
      method: "POST",
      path: `/meta/${e}/digital-content/${t}gallery/${s}/section/${o}/item/${n}/tag/${r}`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(a);
  }
  metaRemoveTagToSectionItem(e, t, s, o, n, r) {
    const a = {
      method: "DELETE",
      path: `/meta/${e}/digital-content/${t}gallery/${s}/section/${o}/item/${n}/tag/${r}`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(a);
  }
}
class kt {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  inviteProvider(e) {
    const t = {
      method: "POST",
      path: "/serviceProvider/invite",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  resendInviteProvider(e) {
    const t = {
      method: "POST",
      path: "/serviceProvider/resendInvite",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  createOffer(e, t) {
    const s = {
      method: "POST",
      path: `/serviceProvider/${e}/offer`,
      body: t,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  createOfferAsAdmin(e, t) {
    const s = {
      method: "POST",
      path: `/admin/serviceProvider/${e}/offer`,
      body: t,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  getOffer(e, t) {
    const s = {
      method: "GET",
      path: `/serviceProvider/${e}/offer/${t}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  updateOffer(e, t, s) {
    const o = {
      method: "PUT",
      path: `/serviceProvider/${e}/offer/${t}`,
      body: s,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  updateOfferAsAdmin(e, t, s) {
    const o = {
      method: "PUT",
      path: `/admin/serviceProvider/${e}/offer/${t}`,
      body: s,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  deleteOffer(e, t) {
    const s = {
      method: "DELETE",
      path: `/serviceProvider/${e}/offer/${t}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  deleteOfferAsAdmin(e) {
    const t = {
      method: "DELETE",
      path: `/serviceProvider/offer/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  fetchOwnOffers() {
    const e = {
      method: "GET",
      path: "/serviceProvider/listOwnOffers",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  fetchOAllffers() {
    const e = {
      method: "GET",
      path: "/serviceProvider/offers",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  fetchServiceOrders(e) {
    const t = {
      method: "GET",
      path: `/serviceProvider/${e}/getServiceOrderTicketsByServiceProvider`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  fetchAllServiceOrders() {
    const e = {
      method: "GET",
      path: "/serviceProvider/fetchAllServiceOrders",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
}
class Rt {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  async createCampaign(e) {
    const t = {
      method: "POST",
      path: "/mail-coaching/create",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  getAllCampaigns(e) {
    const t = {
      method: "GET",
      path: "/mail-coaching",
      params: {
        product: e
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  getCampaignById(e) {
    const t = {
      method: "GET",
      path: `/mail-coaching/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  deleteCampaign(e) {
    const t = {
      method: "DELETE",
      path: `/mail-coaching/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  deleteSequence(e, t) {
    const s = {
      method: "DELETE",
      path: `/mail-coaching/${e}/delete-sequence/${t}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  updateCampaign(e, t) {
    const s = {
      method: "PUT",
      path: `/mail-coaching/${e}/update`,
      body: t,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  createSequence(e, t) {
    const s = {
      method: "PUT",
      path: `/mail-coaching/${e}/add-sequence`,
      body: t,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  updateSequence(e, t) {
    const s = {
      method: "PUT",
      path: `/mail-coaching/${e}/update-sequence`,
      body: t,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  subscribeToMailCoaching(e, t, s) {
    const o = {
      method: "POST",
      path: `/mail-coaching/subscribe/${e}`,
      body: {
        objectType: "TICKET",
        objectId: t,
        notification: "CREATOR",
        startDate: s
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  unsubscribeFromCampaign(e, t) {
    const s = {
      method: "POST",
      path: `/mail-coaching/unsubscribe/${e}`,
      body: {
        objectId: t,
        objectType: "TICKET"
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  fetchSubscriptions(e, t = "TICKET") {
    const s = {
      method: "GET",
      path: `/mail-coaching/fetch-subscription/${e}/${t}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
}
class xt {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  fetchTopicStatsById(e, t) {
    const s = {
      method: "GET",
      path: `/stats/fetchTopicStats/${t}/${e}`,
      params: {
        cached: !0
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  fetchTopicStatsByBatch(e, t) {
    const s = {
      method: "POST",
      path: `/stats/fetchTopicStatsByBatch/${t}`,
      params: {
        cached: !0
      },
      body: {
        topicIds: e
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  fetchTeamStatsById(e, t) {
    const s = {
      method: "GET",
      path: `/stats/fetchTeamStats/${t}/${e}`,
      params: {
        cached: !0
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  fetchTeamStatsByBatch(e, t) {
    const s = {
      method: "POST",
      path: `/stats/fetchTeamStatsByBatch/${t}`,
      params: {
        cached: !0
      },
      body: {
        targets: e
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  fetchTicketStats(e) {
    const t = {
      method: "GET",
      path: "/stats/fetchTicketStats",
      params: {
        type: e,
        cached: !0
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
}
class $t {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  createTeam(e) {
    const t = {
      method: "POST",
      path: "/team",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  updateTeam(e) {
    const t = {
      method: "PUT",
      path: `/team/${e.id}`,
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  getTeam(e, t) {
    const s = {
      method: "GET",
      path: `/team/${e}`,
      useContext: !0,
      useAuth: !0,
      context: t
    };
    return this.client.doRequest(s);
  }
  getAllTeams(e) {
    const t = {
      method: "GET",
      path: "/team/fetchAll",
      params: {
        teamType: e
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  getTeamsByBatch(e, t) {
    const s = {
      method: "POST",
      path: "/team/fetchByBatch",
      useContext: !0,
      useAuth: !0,
      body: {
        teamIds: e
      },
      context: t
    };
    return this.client.doRequest(s);
  }
  deleteTeam(e) {
    const t = {
      method: "DELETE",
      path: `/team/${e}/dependencies`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  bulkAddUserToTeam(e, t) {
    const s = {
      method: "POST",
      path: "/admin/team/bulk/add",
      body: { teamId: e, userIds: t },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  addTeamMember({ teamId: e, userId: t, role: s }) {
    const o = {
      method: "POST",
      path: `/team/${e}/member/${t}/${s}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  removeTeamMember({ teamId: e, userId: t, role: s }) {
    const o = {
      method: "DELETE",
      path: `/team/${e}/member/${t}`,
      params: {
        role: s
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  fetchTeamMembers(e) {
    const t = {
      method: "GET",
      path: `/team/${e}/members`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  fetchSubscribedTeams(e, t) {
    const s = {
      method: "GET",
      path: `/team/${e}/subscribedTeams`,
      useContext: !0,
      useAuth: !0,
      context: t
    };
    return this.client.doRequest(s);
  }
  // Admin APIs
  createTeamAsAdmin(e) {
    const t = {
      method: "POST",
      path: "/admin/team",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  updateTeamAsAdmin(e) {
    const t = {
      method: "PUT",
      path: `/admin/team/${e.id}`,
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  deleteTeamAsAdmin(e, t = !1) {
    const s = {
      method: "DELETE",
      path: `/admin/team/${e}/dependencies`,
      params: {
        force: t
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  addTeamMemberAsAdmin({
    teamId: e,
    userId: t,
    role: s
  }) {
    const o = {
      method: "POST",
      path: `/admin/team/${e}/member/${t}/${s}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  removeTeamMemberAsAdmin({
    teamId: e,
    userId: t,
    role: s
  }) {
    const o = {
      method: "DELETE",
      path: `/admin/team/${e}/member/${t}`,
      params: {
        role: s
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  // Co Creator Team APIs
  createCoCreatorTeam(e) {
    const t = {
      method: "POST",
      path: "/cocreator-team",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  updateCoCreatorTeam(e) {
    const t = {
      method: "PUT",
      path: `/cocreator-team/${e.id}`,
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  deleteCoCreatorTeam(e) {
    const t = {
      method: "DELETE",
      path: `/cocreator-team/${e}/dependencies`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  addCoCreator({ teamId: e, userId: t, role: s }) {
    const o = {
      method: "POST",
      path: `/cocreator-team/${e}/member/${t}/${s}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  removeCoCreator({ teamId: e, userId: t, role: s }) {
    const o = {
      method: "DELETE",
      path: `/cocreator-team/${e}/member/${t}`,
      params: {
        role: s
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  fetchCoCreatorTeamByName(e) {
    const t = {
      method: "GET",
      path: "/cocreator-team/fetchByName",
      params: {
        searchText: e
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  fetchCoCreatorTeamByNamePageable(e) {
    const t = {
      method: "GET",
      path: "/cocreator-team/pageable",
      params: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  fetchCoCreatorTeamById(e) {
    const t = {
      method: "GET",
      path: `/cocreator-team/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
}
class bt {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  getTicket(e, t) {
    const s = {
      method: "GET",
      path: `/ticket/${e}/${t}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  async fetchChildTickets(e, t, s) {
    const o = {
      method: "GET",
      path: `/ticket/${e}/${t}/children`,
      params: {
        types: s
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  async fetchChildTicketsByBatch(e, t, s, o, n) {
    const r = {
      method: "POST",
      path: `/ticket/${e}/batch/${s}/children/aggregation`,
      params: {
        group: o,
        audience: n
      },
      body: {
        targets: t
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(r);
  }
  fetchTicketsByBatch(e, t, s) {
    const o = {
      method: "POST",
      path: `/ticket/${t}/fetchByCanonicalIdByBatch`,
      useContext: !0,
      useAuth: !0,
      body: {
        context: e,
        targets: s
      }
    };
    return this.client.doRequest(o);
  }
  updateTicket(e, t, s) {
    const o = {
      method: "PUT",
      path: `/ticket/${e}/${t}`,
      body: s,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  updateTicketStatus(e, t, s) {
    const o = {
      method: "PUT",
      path: `/ticket/${e}/${t}/status`,
      body: {
        status: s
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  updateTicketCreator(e, t, s) {
    const o = {
      method: "PUT",
      path: `/admin/ticket/${e}/${t}/creator/${s}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  createTicket(e, t) {
    const s = {
      method: "POST",
      path: `ticket/${e}`,
      body: t,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  getTicketHistory(e, t) {
    const s = {
      method: "GET",
      path: `/ticket/${e}/${t}/history`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  updateTasks(e, t, s) {
    const o = {
      method: "PUT",
      path: `/ticket/${e}/${t}/tasks`,
      body: { tasks: s },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  deleteTicket(e, t) {
    const s = {
      method: "DELETE",
      path: `/admin/ticket/${e}/${t}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  copyTicket(e, t, s) {
    const o = {
      method: "POST",
      path: `/ticket/${t}/${s}/copy/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  moveTicket(e, t, s) {
    const o = {
      method: "POST",
      path: `/ticket/${t}/${s}/move/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  bulkCopyTicket(e, t) {
    const s = {
      method: "POST",
      path: `/admin/ticket/${t}/copy/bulk`,
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  bulkMoveTicket(e, t) {
    const s = {
      method: "POST",
      path: `/admin/ticket/${t}/move/bulk`,
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  deleteSubProduct(e, t, s) {
    const o = {
      method: "DELETE",
      path: `/ticket/${e}/${s}/${t}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  removeTicketFile(e, t) {
    const s = {
      method: "DELETE",
      path: `/ticket/fileUpload/${e}/${t}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  fetchPurchaseAudience(e) {
    const t = {
      method: "GET",
      path: "/ticket/purchase-audience/own/all",
      params: {
        type: e
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  fetchTicketAssigneeAudience(e, t, s) {
    const o = {
      method: "POST",
      path: `/ticket/${s}/${t}/assignee/audience`,
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  fetchTicketSkills(e, t) {
    const s = {
      method: "GET",
      path: `/ticket/${e}/${t}/skills`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  updateTicketSkills(e, t, s) {
    const o = {
      method: "POST",
      path: `/ticket/${e}/${t}/skills`,
      body: { skills: s },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  addTicketSkill(e, t, s) {
    const o = {
      method: "POST",
      path: `/ticket/${e}/${t}/skill`,
      body: { skill: s },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  removeTicketSkill(e, t, s) {
    const o = {
      method: "DELETE",
      path: `/ticket/${e}/${t}/skill`,
      body: { skill: s },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  generateTicketAi(e, t, s) {
    const o = {
      method: "POST",
      path: `/ticket/${e}/${t}/ai/generate`,
      body: s,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  bulkUpdateStatus(e, t) {
    const s = {
      method: "POST",
      path: `/ticket/${e}/status/bulk`,
      body: t,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  bulkUpdateTicket(e, t) {
    const s = {
      method: "POST",
      path: `/ticket/${e}/bulk`,
      body: t,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  bulkDeleteTickets(e, t) {
    const s = {
      method: "DELETE",
      path: `admin/ticket/${e}/bulk`,
      body: t,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  fetchBulkAction(e) {
    const t = {
      method: "GET",
      path: `/bulk/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  // Temporary until the real endpoint is finished
  genericAIPrompt(e) {
    const t = {
      method: "POST",
      path: "/ai/raw/completions",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  // genericAIPrompt(request: IOpenAIRequest): Promise<IOpenAIResponse> {
  //   const options: IRequestOptions = {
  //     method: 'POST',
  //     path: `/ai/completions`,
  //     body: request,
  //     useContext: true,
  //     useAuth: true
  //   };
  //   return this.client.doRequest(options);
  // }
  createAITicket(e, t, s) {
    const o = {
      method: "POST",
      path: `/ai/${e}/get-inspired`,
      body: {
        campaignCanonicalId: t,
        ticketSuggestion: s
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  bulkInspirePeople(e, t) {
    const s = {
      method: "POST",
      path: `/ai/bulk/${e}/inspire-people`,
      body: t,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  validateUserByTicketType(e, t) {
    const s = {
      method: "GET",
      path: `/ticket/${t}/${e}/validateUserByTicketType`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
}
class Et {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  createTopic(e) {
    const t = {
      method: "POST",
      path: "/admin/topic",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  updateTopic(e) {
    const t = {
      method: "PUT",
      path: `/admin/topic/${e.id}`,
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  deleteTopic(e) {
    const t = {
      method: "DELETE",
      path: `/admin/topic/${e}?force=true`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  async getTopic(e) {
    const t = {
      method: "GET",
      path: `/topic/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  async getAllTopics() {
    const e = {
      method: "GET",
      path: "/topic/fetchAll",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  async fetchTopicByBatch(e) {
    const t = {
      method: "POST",
      path: "/topic/fetchByBatch",
      body: {
        topicIds: e
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  async fetchTopicTags(e) {
    const t = {
      method: "GET",
      path: `/topic/${e}/tags`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  getTopicByTeam(e, t) {
    const s = {
      method: "GET",
      path: `/topic/relationshipByTeam/${e}`,
      params: {
        relationshipType: t
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  getTopicByTags(e) {
    const t = {
      method: "POST",
      path: "/topic/tagFilter",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  getTeamByTopic(e, t) {
    const s = {
      method: "GET",
      path: `/topic/relationshipToTeams/${e}`,
      params: {
        relationshipType: t
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  setTeamByTopic(e, t, s) {
    const o = {
      method: "POST",
      path: "/topic/relationshipToTeams",
      params: {
        relationshipType: t,
        deleteOthers: s
      },
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  fetchCurrentUserTopics(e) {
    const t = {
      method: "GET",
      path: "/topic/findRelatedTopics",
      params: {
        relationshipType: e
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  setTopicUserRelationship(e, t) {
    const s = {
      method: "POST",
      path: "/topic/subscribeUser",
      params: {
        relationshipType: t
      },
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  removeUserRelationship(e, t) {
    const s = {
      method: "DELETE",
      path: "/topic/removeUserRelationship",
      params: {
        relationshipType: t
      },
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  fetchRelatedUsers(e, t) {
    const s = {
      method: "GET",
      path: "/topic/findRelatedUsers",
      params: {
        topicId: e,
        relationshipType: t
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
}
class Ot {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  fetchVersionNumber() {
    const e = {
      method: "GET",
      path: "/currentVersion",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  getUser(e, t) {
    const s = {
      method: "GET",
      path: `/user/${e}`,
      useContext: !0,
      useAuth: !0,
      context: t
    };
    return this.client.doRequest(s);
  }
  updateUser(e, t) {
    const s = {
      method: "PUT",
      path: `/user/${e}`,
      body: t,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  deleteUser(e) {
    const t = {
      method: "DELETE",
      path: `/user/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  deleteUserSelf() {
    const e = {
      method: "DELETE",
      path: "/user",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  uninviteUser(e) {
    const t = {
      method: "POST",
      path: `/user/uninvite/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  fetchUsersByBatch(e, t) {
    const s = {
      method: "POST",
      path: "/users/fetchByBatch",
      body: {
        targets: e
      },
      useContext: !0,
      useAuth: !0,
      context: t
    };
    return this.client.doRequest(s);
  }
  fetchUriByBatch(e) {
    const t = {
      method: "POST",
      path: "/users/fetchUriByBatch",
      body: {
        targets: e
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  fetchUserRolesByBatch(e) {
    const t = {
      method: "POST",
      path: "/users/fetchRolesByBatch",
      body: {
        targets: e
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  fetchUserRoles(e) {
    const t = {
      method: "GET",
      path: `/users/fetchRolesByContext/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  updateUserRoles(e, t) {
    const s = {
      method: "POST",
      path: `/user/${e}/updateRole`,
      body: t,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  bulkUpdateUserRoles(e, t, s) {
    const o = {
      method: "POST",
      path: "admin/user/roles/bulk",
      body: {
        userIds: t,
        userRoleUpdateRequest: {
          roles: e,
          operation: s
        }
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  metaUpdateUserRoles(e, t, s) {
    const o = {
      method: "POST",
      path: `/meta/${e}/user/${t}/updateRole`,
      body: s,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  metaUserSearch(e, t) {
    const s = {
      method: "POST",
      path: `/meta/${e}/user`,
      body: t,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  metaGetUser(e, t) {
    const s = {
      method: "GET",
      path: `/meta/${t}/user/user/${e}`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  metaFetchByBatch(e, t) {
    const s = {
      method: "POST",
      path: `/meta/${e}/user/fetchByBatch`,
      body: {
        targets: t
      },
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  metaResetMfa(e, t) {
    const s = {
      method: "PATCH",
      path: `/meta/${e}/user/resetMfa`,
      params: {
        userId: t
      },
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  metaUninviteUser(e, t) {
    const s = {
      method: "POST",
      path: `/meta/${e}/user/uninvite/${t}`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
}
class qt {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  async fetchWorkflow(e, t) {
    const s = {
      method: "GET",
      path: `/workflow/${e}`,
      useContext: !0,
      useAuth: !0,
      context: t
    };
    return this.client.doRequest(s);
  }
  async metaFetchWorkflow(e, t) {
    const s = {
      method: "GET",
      path: `/meta/workflow/${t}/${e}`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
}
class vt {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  fetchSkillCatalog(e) {
    const t = {
      method: "GET",
      path: "/skills/catalog",
      params: {
        includePopulatedSkills: e
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  fetchCurrentUserSkills() {
    const e = {
      method: "GET",
      path: "/skills/user",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  addSkill(e) {
    const t = {
      method: "POST",
      path: "/skills/user",
      params: {
        skill: e
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  deleteSkill(e) {
    const t = {
      method: "DELETE",
      path: "/skills/user",
      params: {
        skill: e
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  fetchSkillsFromOtherUser(e) {
    const t = {
      method: "GET",
      path: `/skills/user/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  addSkillToUser(e, t) {
    const s = {
      method: "POST",
      path: `/skills/user/${e}`,
      params: {
        skill: t
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  deleteSkillFromOtherUser(e, t) {
    const s = {
      method: "DELETE",
      path: `/skills/user/${e}`,
      params: {
        skill: t
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  fetchSkillsByContext() {
    const e = {
      method: "GET",
      path: "/skills/user/list",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
}
class St {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  fetchActiveDirectory() {
    const e = {
      method: "GET",
      path: "/admin/activeDirectory",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  updateActiveDirectory(e) {
    const t = {
      method: "POST",
      path: "/admin/activeDirectory",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  enableActiveDirectory() {
    const e = {
      method: "PUT",
      path: "/admin/activeDirectory/enable",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  disableActiveDirectory() {
    const e = {
      method: "PUT",
      path: "/admin/activeDirectory/disable",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  syncActiveDirectory() {
    const e = {
      method: "PATCH",
      path: "/admin/activeDirectory/sync",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
}
class Pt {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  fetchTags() {
    const e = {
      method: "GET",
      path: "/offer/tags/system",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
}
class Bt {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  fetchWatcherForTarget(e, t) {
    const s = {
      method: "GET",
      path: "/watcher",
      params: {
        targetId: e,
        targetType: t
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  setWatcherForTarget(e, t, s) {
    const o = {
      method: "PUT",
      path: "/watcher",
      body: {
        targetId: e,
        targetType: t,
        action: s
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
}
class Dt {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  getMetaDashboards(e) {
    const t = {
      method: "GET",
      path: `/meta/${e}/dashboard`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  getMetaDashboardById(e, t) {
    const s = {
      method: "GET",
      path: `/meta/${e}/dashboard/${t}`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  addMetaDashboard(e, t) {
    const s = {
      method: "POST",
      path: `/meta/${e}/dashboard`,
      body: t,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  updateMetaDashboard(e, t, s) {
    const o = {
      method: "PUT",
      path: `/meta/${e}/dashboard/${t}`,
      body: s,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  deleteMetaDashboard(e, t) {
    const s = {
      method: "DELETE",
      path: `/meta/${e}/dashboard/${t}`,
      useContext: !1,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  getAdminDashboards() {
    const e = {
      method: "GET",
      path: "/dashboard",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  getAdminDashboardById(e) {
    const t = {
      method: "GET",
      path: `/dashboard/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
}
class Gt {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  getSimilarityTickets(e) {
    const t = {
      method: "POST",
      path: "/similarity-search/ticket",
      body: [e],
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
}
class Ut {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  fetchGenericTagsCatalog(e) {
    const t = {
      method: "GET",
      path: `/generic/tags/${e}/context`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  fetchGenericTags(e, t) {
    const s = {
      method: "GET",
      path: `/generic/tags/${e}/${t}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  fetchTargetsByTag(e, t) {
    const s = {
      method: "POST",
      path: `/generic/tags/${e}/fetchTargetIdsByBatch`,
      body: { genericTags: t },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
  addGenericTags(e, t, s) {
    const o = {
      method: "POST",
      path: `/generic/tags/${e}/${t}/addTags`,
      body: {
        genericTags: s
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  removeGenericTags(e, t, s) {
    const o = {
      method: "DELETE",
      path: `/generic/tags/${e}/${t}/removeTags`,
      body: {
        genericTags: s
      },
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
}
class It {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  updateTicketFilePermissions(e, t, s, o) {
    const n = {
      method: "POST",
      path: `/ticket/${e}/${t}/permissions/${s}`,
      body: o,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(n);
  }
}
class Ft {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  getOrganizationAiPrompt(e) {
    const t = {
      method: "GET",
      path: `/admin/organization/settings/ai/${e}/prompt`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  saveOrganizationAiPrompt(e, t, s) {
    const o = {
      method: "POST",
      path: `/admin/organization/settings/ai/${e}/prompt/${t}`,
      body: s,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(o);
  }
  getOrganizationAiSettings() {
    const e = {
      method: "GET",
      path: "/admin/organization/settings/ai",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  saveOrganizationAiSettings(e) {
    const t = {
      method: "POST",
      path: "/admin/organization/settings/ai",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
}
class jt {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  getAllAgents() {
    const e = {
      method: "GET",
      path: "/ai/agents",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  fetchAgent(e) {
    const t = {
      method: "GET",
      path: `/ai/agents/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  saveOrUpdateAgent(e) {
    const t = {
      method: "POST",
      path: "/ai/agents",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  deleteAgent(e) {
    const t = {
      method: "DELETE",
      path: `/ai/agents/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
}
class zt {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  getPipelines() {
    const e = {
      method: "GET",
      path: "/kafka",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  getPipelineById(e) {
    const t = {
      method: "GET",
      path: `/kafka/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  savePipeline(e) {
    const t = {
      method: "PUT",
      path: `/kafka/${e.id}`,
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  createPipeline(e) {
    const t = {
      method: "POST",
      path: "/kafka",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  deletePipeline(e) {
    const t = {
      method: "DELETE",
      path: `/kafka/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  startPipeline(e) {
    const t = {
      method: "POST",
      path: `/kafka/${e}/start`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  stopPipeline(e) {
    const t = {
      method: "POST",
      path: `/kafka/${e}/stop`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  getQueues() {
    const e = {
      method: "GET",
      path: "/kafka/queues",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
}
class Mt {
  constructor(e) {
    h(this, "client");
    this.client = e;
  }
  getEventCollectors() {
    const e = {
      method: "GET",
      path: "/admin/eventCollector/eventType",
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(e);
  }
  getEventCollector(e) {
    const t = {
      method: "GET",
      path: `/admin/eventCollector/eventType/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  createEventCollector(e) {
    const t = {
      method: "POST",
      path: "/admin/eventCollector/eventType",
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  deleteEventCollector(e) {
    const t = {
      method: "DELETE",
      path: `/admin/eventCollector/eventType/${e}`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  eventCollectorAttributes(e) {
    const t = {
      method: "GET",
      path: `/eventCollector/eventType/${e}/attributes`,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(t);
  }
  updateEventCollector(e) {
    const { eventType: t } = e, s = {
      method: "PUT",
      path: `/admin/eventCollector/eventType/${t}`,
      body: e,
      useContext: !0,
      useAuth: !0
    };
    return this.client.doRequest(s);
  }
}
class Wt {
  constructor(e) {
    h(this, "mocks");
    this.mocks = e;
  }
  fetch(e, t) {
    const s = this.getMock(e, t);
    if (s.status && s.status !== 200)
      throw new Error("All hope abandon ye who enter here");
    return new Promise((o) => {
      setTimeout(() => (console.debug(`Mocking request ${e}:`, s.body), o(s.body)), s.timeout ?? 0);
    });
  }
  isMocked(e, t) {
    return !!this.getMock(e, t);
  }
  getMock(e, t) {
    var s;
    return (s = Object.entries(this.mocks).find(
      ([o, { method: n }]) => e.includes(o) && (!n || n.toLowerCase() === t.toLowerCase())
    )) == null ? void 0 : s[1];
  }
}
const Lt = {
  "example/url": {
    body: { test: !0 },
    status: 200,
    timeout: 0
  }
};
class _t {
  constructor(e) {
    h(this, "options");
    h(this, "mock");
    this.options = e, e.mock && (this.mock = new Wt(Lt));
  }
  get isMockEnabled() {
    return this.options.mock;
  }
  get context() {
    return this.options.contextOptions;
  }
  get handlers() {
    return this.options.handlerOptions;
  }
  async doRequest(e) {
    var a;
    const t = this.buildUrl(
      e.path,
      e.params,
      e.useContext,
      e.context,
      e.url
    ), s = e.content ?? "json", o = this.buildHeaders(s, e.useAuth);
    e.headers && Object.assign(o, e.headers);
    const n = s === "json" ? JSON.stringify(e.body) : e.body, r = {
      method: e.method,
      headers: o,
      body: n
    };
    try {
      if ((a = this.mock) != null && a.isMocked(t, e.method))
        return this.mock.fetch(t, e.method);
      const u = await fetch(t, r);
      return this.handleResponse(u);
    } catch (u) {
      throw new Error(u);
    }
  }
  buildHeaders(e, t) {
    const s = {};
    if (s["Content-Type"] = "application/json", s["app-id"] = this.context.getAppId() ?? "", s.product = this.context.getProduct() ?? "", e === "form" ? delete s["Content-Type"] : e === "json" && (s["Content-Type"] = "application/json"), t) {
      const o = this.context.getToken();
      s.Authorization = `Bearer ${o}`;
    }
    return s;
  }
  buildUrl(e, t, s, o, n) {
    let r = null;
    if (t) {
      const d = Object.entries(t).filter(
        ([p, f]) => f != null
      );
      r = new URLSearchParams(d);
    }
    const a = r ? `?${r.toString()}` : "";
    if (n)
      return `${n}${a}`;
    const u = s ? `/${o ?? this.context.getContext()}` : "", c = e.startsWith("/") ? e : `/${e}`;
    return `${this.options.baseUrl}${u}${c}${a}`;
  }
  getHandler(e) {
    return e === 406 ? this.handlers.onAuthError ?? this.handlers.onError : e >= 400 && e < 500 ? this.handlers.onClientError ?? this.handlers.onError : e >= 500 && e < 600 ? this.handlers.onServerError ?? this.handlers.onError : this.handlers.onError;
  }
  async handleResponse(e) {
    try {
      if (e.ok)
        return e.headers.get("content-length") == "0" ? Promise.resolve() : e.headers.get("Content-Type") === "application/json" ? e.json() : e.text();
      const t = this.getHandler(e.status), s = await e.text();
      t(s);
      const o = {
        message: s,
        status: e.status,
        resources: void 0,
        details: void 0
      };
      try {
        const n = JSON.parse(s);
        o.message = n.message, o.resources = n.resources, o.details = n.details;
      } catch {
      }
      return Promise.reject(o);
    } catch (t) {
      return this.handlers.onError(t), Promise.reject(t);
    }
  }
}
function O(i) {
  return [...new Set(i)].filter((t) => !!t);
}
function x(i, e) {
  return [...new Set(i.map(e))].filter((s) => !!s);
}
function Ee(i, e) {
  const t = /* @__PURE__ */ new Map();
  for (const s of i) {
    const o = e(s);
    t.has(o) || t.set(o, []), t.get(o).push(s);
  }
  return t;
}
function y(i, e) {
  const t = /* @__PURE__ */ new Map();
  for (const s of i) {
    const o = e(s);
    if (!t.has(o))
      t.set(o, s);
    else
      throw new Error("Could not mapBy: Multiple values with the same key");
  }
  return t;
}
function Nt(i, e) {
  const t = i.split(".");
  let s = e;
  for (const o of t)
    if (s = s[o], !s)
      return;
  return s;
}
const Oe = ["completions", "image", "embedding"];
function F(i, e) {
  const { query: t, filter: s, sort: o, limit: n } = i, r = s == null ? void 0 : s[e];
  if (!Array.isArray(r))
    throw new Error(
      `Grouping parameter '${e.toString()}' must be an array`
    );
  return (r == null ? void 0 : r.length) === 0 ? (console.error(`Grouping parameter '${e.toString()}' cannot be empty`), []) : r.map((a) => ({
    query: t,
    filter: {
      ...s,
      [e]: [a]
    },
    limit: n,
    sort: o
  }));
}
class E {
  constructor(e) {
    h(this, "query");
    h(this, "terms");
    h(this, "orderBy");
    h(this, "resultLimit");
    this.query = (e ?? "").trim().replaceAll("*", ""), this.terms = [], this.orderBy = { field: "createdDate", direction: "DESC" };
  }
  static query(e) {
    return new E(e);
  }
  filter(e, t, s = "EQUAL") {
    return (s === "EXISTS" || t && t.length > 0) && this.terms.push({
      field: e,
      match: t,
      matchMode: s
    }), this;
  }
  contextFilter(e, t, s, o = "EQUAL") {
    if (s === void 0)
      return this;
    if (!e)
      return console.error(`Filter parameter '${t}' requires 'context' to be set`), this;
    const { replace: n } = Vt(t), r = n({ context: e });
    return (o === "EXISTS" || s && s.length > 0) && this.terms.push({
      field: r,
      match: s,
      matchMode: o
    }), this;
  }
  sort(e) {
    return e && (this.orderBy = e), this;
  }
  limit(e) {
    return this.resultLimit = e, this;
  }
  build() {
    return {
      query: `${this.query}*`,
      order: this.orderBy,
      where: this.terms,
      limit: this.resultLimit
    };
  }
}
const Ht = /{\s*[\w.]+\s*}/g, Jt = /{{\s*[\w.]+\s*}}/g, Kt = /[\w.]+/;
function Vt(i, e) {
  const s = { mustache: "double", ...e }.mustache === "single" ? Ht : Jt, o = i.match(s) ?? [];
  return { replace: (r) => {
    let a = i;
    return o.forEach((u) => {
      var p;
      const c = (p = u == null ? void 0 : u.match(Kt)) == null ? void 0 : p[0], d = c ? r[c] : void 0;
      d !== void 0 && (a = a.replace(u, d));
    }), a;
  } };
}
function Qt(i, e) {
  if (e.startsWith("secondaryId:")) {
    const t = e.substring(12);
    return i.values().find((s) => s.value.secondaryId === t);
  }
  console.error("SecondaryId formatting error");
}
class k {
  constructor(e, t = 60) {
    h(this, "keyField");
    h(this, "expirationMinutes");
    h(this, "map");
    this.keyField = Array.isArray(e) ? e : [e], this.expirationMinutes = t, this.map = /* @__PURE__ */ new Map();
  }
  get size() {
    return this.map.size;
  }
  clear() {
    this.map.clear();
  }
  put(e) {
    if (!e)
      return;
    const t = {
      expiration: this.newExpiration(),
      value: e
    };
    this.map.set(this.getKey(e), t);
  }
  putBatch(e) {
    e.forEach((t) => {
      this.put(t);
    });
  }
  get(e) {
    const t = Array.isArray(e) ? e.join("|") : e;
    let s;
    if (t.startsWith("secondaryId:") ? s = Qt(this.map, t) : s = this.map.get(t), s !== void 0) {
      if (s.expiration < /* @__PURE__ */ new Date()) {
        this.map.delete(t);
        return;
      }
      return s.value;
    }
  }
  getBatch(e) {
    const t = [], s = [];
    return e.forEach((o) => {
      const n = this.get(o);
      n ? s.push(n) : t.push(o);
    }), {
      hit: s,
      miss: t
    };
  }
  remove(e) {
    const t = Array.isArray(e) ? e.join("|") : e;
    this.map.delete(t);
  }
  removeBatch(e) {
    e.forEach((t) => {
      const s = Array.isArray(t) ? t.join("|") : t;
      this.map.delete(s);
    });
  }
  newExpiration() {
    const e = /* @__PURE__ */ new Date();
    return e.setMinutes(e.getMinutes() + this.expirationMinutes), e;
  }
  getKey(e) {
    const t = this.keyField.map((s) => Nt(s, e)).join("|");
    if (t === void 0)
      throw new Error(`Could not find cache key [${this.keyField}] on object.`);
    if (typeof t != "string")
      throw new Error(`Cannot use [${this.keyField}] as SdkCache key.`);
    return t;
  }
}
class R {
  constructor(e) {
    h(this, "cache");
    this.cache = e;
  }
  reset() {
    this.cache.clear();
  }
  clearCache(e) {
    this.cache.removeBatch(e);
  }
  async fetchOne(e) {
    const t = await e();
    return this.cache.put(t), t;
  }
  async fetchMany(e) {
    const t = await e();
    return this.cache.putBatch(t), t;
  }
  async findOne(e, t) {
    const s = this.cache.get(e);
    if (s)
      return s;
    const o = await t();
    return this.cache.put(o), o;
  }
  async findMany(e, t) {
    const s = O(e), { hit: o, miss: n } = this.cache.getBatch(s);
    if (o.length === s.length)
      return o;
    if (t.length === 0)
      throw new Error(
        "OnMissMany callback function (used on SdkDatasource.findMany) is expected to have an argument"
      );
    let r = [];
    try {
      r = await t(n);
    } catch (a) {
      console.error("Error loading with FindMany", a);
    }
    return this.cache.putBatch(r), s.map((a) => this.cache.get(a)).filter(Boolean);
  }
  async addOne(e) {
    const t = await e();
    return t === void 0 && console.warn("Could not add created entry to cache"), this.cache.put(t), t;
  }
  async removeOne(e, t) {
    await t(), this.cache.remove(e);
  }
  async updateOne(e) {
    const t = await e();
    return t === void 0 && console.warn("Could not add updated entry to cache"), this.cache.put(t), t;
  }
}
class Xt extends R {
  constructor(t) {
    super(new k(["type", "context"], 60));
    h(this, "dynamicFields");
    this.dynamicFields = t;
  }
  find(t, s) {
    return super.findOne(
      [t, s],
      () => this.dynamicFields.fetchDynamicTypes(t, s)
    );
  }
  update(t, s) {
    return super.updateOne(
      () => this.dynamicFields.updateDynamicFieldConfiguration(
        t,
        s
      )
    );
  }
}
class Zt extends R {
  constructor(t) {
    super(new k("id", 60));
    h(this, "api");
    this.api = t;
  }
  listBatch(t) {
    return super.findMany(t, async (s) => {
      const o = [], n = await this.api.fetchReactionBoard(s);
      return Object.keys(n).forEach((r) => {
        const a = n[r];
        a && (a.id = r, o.push(a));
      }), o;
    });
  }
  async create(t, s, o) {
    return await this.api.createReaction(t, s, o), this.refreshReactionBoard(t);
  }
  async remove(t, s, o) {
    return await this.api.deleteReaction(t, s, o), this.refreshReactionBoard(t);
  }
  // Refreshes the reaction board to update the comment count
  async refreshReactionBoard(t) {
    this.cache.remove(t);
    const s = await this.listBatch([t]);
    return s.length === 1 ? s[0] : void 0;
  }
}
class Yt extends R {
  constructor(t) {
    super(new k("id", 60));
    h(this, "api");
    this.api = t;
  }
  create(t) {
    return super.addOne(() => this.api.createTeam(t));
  }
  fetchSubscribedTeams(t, s) {
    return super.fetchMany(
      () => this.api.fetchSubscribedTeams(t, s)
    );
  }
  list(t) {
    return super.fetchMany(() => this.api.getAllTeams(t));
  }
  listBatch(t, s) {
    return super.findMany(
      t,
      (o) => this.api.getTeamsByBatch(o, s)
    );
  }
  find(t, s) {
    return super.findOne(t, () => this.api.getTeam(t, s));
  }
  update(t) {
    return super.updateOne(() => this.api.updateTeam(t));
  }
  updateCoCreator(t) {
    return super.updateOne(() => this.api.updateCoCreatorTeam(t));
  }
  // Admin APIs
  createAsAdmin(t) {
    return super.addOne(() => this.api.createTeamAsAdmin(t));
  }
  updateAsAdmin(t) {
    return super.updateOne(() => this.api.updateTeamAsAdmin(t));
  }
}
class te extends R {
  constructor(t) {
    super(new k("canonicalId", 60));
    h(this, "ticket");
    this.ticket = t;
  }
  dirty(t) {
    this.cache.remove(t);
  }
  dirtyBatch(t) {
    this.cache.removeBatch(t);
  }
  async listBatch(t, s, o) {
    return super.findMany(o, async (n) => {
      const r = await this.ticket.fetchTicketsByBatch(
        t,
        s,
        n
      );
      return Object.values(r);
    });
  }
  find(t, s) {
    return super.findOne(
      s,
      () => this.ticket.getTicket(t, s)
    );
  }
  remove(t, s) {
    return super.removeOne(
      s,
      () => this.ticket.deleteTicket(t, s)
    );
  }
  removeSubProduct(t, s, o) {
    return super.removeOne(
      s,
      () => this.ticket.deleteSubProduct(t, s, o)
    );
  }
  update(t, s, o) {
    return super.updateOne(
      () => this.ticket.updateTicket(t, s, o)
    );
  }
  updateStatus(t, s, o) {
    return super.updateOne(
      () => this.ticket.updateTicketStatus(t, s, o)
    );
  }
  updateCreator(t, s, o) {
    return super.updateOne(
      () => this.ticket.updateTicketCreator(t, s, o)
    );
  }
}
class ee extends R {
  constructor(t) {
    super(new k("id", 60));
    h(this, "api");
    this.api = t;
  }
  async list(t) {
    return super.fetchMany(() => this.api.getTicketWallets(t));
  }
}
class se extends R {
  constructor(t, s) {
    super(new k("id", 60));
    h(this, "topic");
    h(this, "feed");
    this.topic = t, this.feed = s;
  }
  create(t) {
    return super.addOne(() => this.topic.createTopic(t));
  }
  list() {
    return super.fetchMany(() => this.topic.getAllTopics());
  }
  filterByTags(t) {
    return super.fetchMany(() => this.topic.getTopicByTags(t));
  }
  listPopular(t, s) {
    return super.fetchMany(async () => (await this.feed.fetchPopularTopics(t, {
      size: s
    })).content);
  }
  listBatch(t) {
    return super.findMany(
      t,
      (s) => this.topic.fetchTopicByBatch(s)
    );
  }
  find(t) {
    return super.findOne(t, () => this.topic.getTopic(t));
  }
  remove(t) {
    return super.removeOne(t, () => this.topic.deleteTopic(t));
  }
  update(t) {
    return super.updateOne(() => this.topic.updateTopic(t));
  }
}
class oe extends R {
  constructor(t, s) {
    super(new k("id", 60));
    h(this, "userApi");
    h(this, "feedApi");
    this.userApi = t, this.feedApi = s;
  }
  findById(t, s) {
    return super.findOne(t, () => this.userApi.getUser(t, s));
  }
  listBatch(t, s) {
    return super.findMany(
      t,
      (o) => this.userApi.fetchUsersByBatch(o, s)
    );
  }
  listMostActive(t, s) {
    return super.fetchMany(async () => {
      const n = (await this.feedApi.fetchMostActiveUsers(t, s)).content.map(({ userId: r }) => r);
      return this.listBatch(n);
    });
  }
}
class ne extends R {
  constructor(t) {
    super(new k(["name", "organisation"], 60));
    h(this, "workflow");
    this.workflow = t;
  }
  find(t, s) {
    return super.findOne(
      [t, s],
      () => this.workflow.fetchWorkflow(t, s)
    );
  }
  metaFind(t, s) {
    return super.findOne(
      [t, s],
      () => this.workflow.metaFetchWorkflow(t, s)
    );
  }
}
class T {
  constructor(e, t) {
    h(this, "api");
    h(this, "datasource");
    this.api = e, this.datasource = t;
  }
  async metaFetchWorkflowsByBatch(e, t) {
    return (await Promise.all(
      e.map(
        (o) => this.datasource.workflow.metaFind(o, t)
      )
    )).filter((o) => !!o);
  }
  async fetchWorkflowsByBatch(e, t) {
    return (await Promise.all(
      e.map(
        (o) => this.datasource.workflow.find(o, t)
      )
    )).filter((o) => !!o);
  }
  async addTeamToUsers(e) {
    const t = x(e, (n) => n.unit);
    let s = [];
    try {
      s = await this.datasource.team.listBatch(t);
    } catch (n) {
      console.log("error", n);
    }
    const o = y(s, (n) => n.id);
    return e.map((n) => ({
      user: n,
      team: o.get(n.unit)
    }));
  }
  async listTeamsWithStats(e, t) {
    const s = await this.listTeams(t), o = s.map((r) => r.id), n = await this.api.stats.fetchTeamStatsByBatch(o, e);
    return s.map((r) => [r, n[r.id]]);
  }
  async listTeams(e, t) {
    return t ? await this.datasource.team.fetchSubscribedTeams(t) : await this.datasource.team.list(e);
  }
  async loadReactionBoard(e) {
    const t = await this.datasource.reaction.listBatch([e]);
    return t.length > 1 ? (console.warn("Unexpected data from Reaction board"), null) : t.length === 0 ? (console.warn("Reaction board not found"), null) : t[0];
  }
  hasUserReacted(e, t, s) {
    const o = e == null ? void 0 : e.reactions.find((n) => n.reactionKey === t);
    return (o == null ? void 0 : o.events.some((n) => n.author === s)) ?? !1;
  }
  async updateReaction(e, t, s, o) {
    return this.hasUserReacted(e, t, o) ? this.datasource.reaction.remove(s, o, t) : this.datasource.reaction.create(s, o, t);
  }
  async createTicketResponse(e, t, s) {
    const o = O(e.map((l) => l.canonicalId)), n = O(e.map((l) => l.type)), r = O(
      e.flatMap((l) => [l.assignee, l.creator])
    ), a = e.filter(
      (l) => l.delegate.length > 0 && l.delegate.some(({ domain: w }) => w === "topic")
    ).map((l) => l.delegate.find(({ domain: w }) => w === "topic").id), u = e.flatMap(
      (l) => l.delegate.filter(({ domain: w }) => ["team", "workgroup"].includes(w)).map(({ id: w }) => w)
    ), c = await Promise.allSettled([
      this.findUsersById(r),
      this.datasource.topic.listBatch(a),
      this.datasource.reaction.listBatch(o),
      this.fetchWorkflowsByBatch(n, t),
      this.datasource.firstCitizen.listBatch(s, o),
      this.datasource.adminFirstCitizen.listBatch(s, o)
    ]), [
      d,
      p,
      f,
      m,
      g,
      C
    ] = c.map((l) => l.status === "fulfilled" ? l.value : []), b = y(m, (l) => l.name), A = y(d, (l) => l.user.id), q = y(p, (l) => l.id), z = f ? y(f, (l) => l.id) : /* @__PURE__ */ new Map(), M = y(
      g,
      (l) => l.parent
    ), W = y(
      C,
      (l) => l.parent
    ), L = e.map((l) => {
      const w = A.get(l.creator), v = A.get(l.assignee);
      return [w == null ? void 0 : w.user.unit, v == null ? void 0 : v.user.unit];
    }).flat().filter((l) => !!l), _ = O([
      ...u,
      ...L
    ]);
    let U = [];
    try {
      U = await this.datasource.team.listBatch(_);
    } catch (l) {
      console.log("Error loading teams", l);
    }
    const I = y(U, (l) => l.id);
    return e.map((l) => {
      const w = A.get(l.creator), v = A.get(l.assignee), N = z.get(l.canonicalId), S = l.delegate.find(
        ($) => $.domain === "topic"
      ), P = l.delegate.find(
        ($) => $.domain === "team"
      ), B = l.delegate.find(
        ($) => $.domain === "workgroup"
      ), D = l.delegate.find(
        ($) => $.domain === "cocreators"
      );
      ({ ...l });
      const H = I.get((P == null ? void 0 : P.id) ?? ""), J = I.get((B == null ? void 0 : B.id) ?? ""), K = q.get((S == null ? void 0 : S.id) ?? ""), V = A.get((D == null ? void 0 : D.id) ?? ""), Q = [
        { type: "topic", data: K },
        { type: "team", data: H },
        { type: "workgroup", data: J },
        { type: "coCreator", data: V }
      ].filter(({ data: $ }) => !!$), X = M.get(l.canonicalId), Z = W.get(l.canonicalId);
      return {
        ticket: l,
        workflow: b.get(l.type),
        creator: w,
        assignee: v,
        delegates: Q,
        board: N,
        firstCitizen: X,
        adminFirstCitizen: Z
      };
    });
  }
  async getDynamicImageUrls(e) {
    return (await this.api.dynamicInformation.fetchDynamicInfoManagement(e, 100)).content.map((s) => s.resources.imageUrl);
  }
  /**
   * Tried to move this outside the gateway but there was no place where it would
   * be accessible for all Apps. Here for now but will be moved eventually
   */
  exportToCsv(e, t, s) {
    const o = e.map((d) => d.label ?? d.key ?? ""), n = e.map((d) => d.key), r = t.map((d) => n.map((p) => d[p])), a = [o, ...r].map(
      (d) => d.map((p) => (p ?? "").toString().replace(/"/g, '""')).map((p) => `"${p}"`).join(",")
    ).join(`
`), u = new Blob([a], { type: "text/csv;charset=utf-8;" }), c = document.createElement("a");
    c.href = URL.createObjectURL(u), c.download = this.createExportFilename(s), c.style.display = "none", document.body.appendChild(c), c.click(), document.body.removeChild(c);
  }
  createExportFilename(e) {
    const t = /* @__PURE__ */ new Date(), s = e.file.locale ? t.toLocaleDateString(e.file.locale).replace(/\//g, "_") : t.toISOString().substring(0, 10);
    return e.file.appendDate ?? !0 ? `${e.file.name}-${s}.csv` : `${e.file.name}.csv`;
  }
  async findUsersById(e) {
    const s = (await this.datasource.user.listBatch(e)).filter((o) => o.firstName || o.lastName);
    return this.addTeamToUsers(s);
  }
  async findUserById(e) {
    const t = await this.datasource.user.listBatch([e]);
    return (await this.addTeamToUsers(t))[0];
  }
  async syncTags(e, t, s) {
    const o = await this.api.genericTags.fetchGenericTags(
      e,
      t
    ), n = s.filter((u) => !o.includes(u)), r = o.filter((u) => !s.includes(u)), a = [];
    n.length && a.push(
      this.api.genericTags.addGenericTags(e, t, n)
    ), r.length && a.push(
      this.api.genericTags.removeGenericTags(e, t, r)
    ), await Promise.all(a);
  }
}
class re extends T {
  constructor(e, t) {
    super(e, t);
  }
  async getAuthenticationSettings() {
    const [e, t, s] = await Promise.allSettled([
      this.api.organizations.fetchCurrentOrganization(),
      this.api.organizations.fetchSsoSettings(),
      this.api.activeDirectory.fetchActiveDirectory()
    ]), o = s.status === "fulfilled" ? s.value : {}, n = t.status === "fulfilled" ? t.value : {};
    return [e.status === "fulfilled" ? e.value : {}, n, o];
  }
  async loadContextBudget(e) {
    const t = await this.api.juoco.fetchCompanyWallet(e);
    if ((t == null ? void 0 : t.length) != 1)
      throw new Error(`Could not load company wallets [companyId=${e}]`);
    const s = t[0], n = (await this.api.juoco.getOrganizationTransactions(
      s.id
    )).extracts.sort(
      (u, c) => Date.parse(c.createdAt) - Date.parse(u.createdAt)
    ), r = x(
      n,
      (u) => u.foreignWalletId
    ), a = await this.api.juoco.fetchWalletOwners(
      r
    );
    return [s, n, a];
  }
  async loadTicketBudget(e, t) {
    const [s, o] = await Promise.all([
      this.api.juoco.fetchCompanyWallet(e),
      this.api.juoco.fetchTicketWallet(t)
    ]);
    if ((s == null ? void 0 : s.length) != 1)
      throw new Error(`Could not load company wallets [companyId=${e}]`);
    if ((o == null ? void 0 : o.length) != 1)
      throw new Error(`Could not load ticket wallets [ticketId=${t}]`);
    const n = s[0], r = o[0], u = (await this.api.juoco.getTicketTransactions(
      r.id
    )).extracts.sort(
      (c, d) => Date.parse(d.createdAt) - Date.parse(c.createdAt)
    );
    return [n, r, u];
  }
}
class ae {
  constructor(e, t) {
    h(this, "api");
    h(this, "datasource");
    this.api = e, this.datasource = t;
  }
  async simplePrompt(e, t, s) {
    var a, u, c;
    const o = {
      model: "gpt-4o-2024-08-06",
      messages: [
        {
          role: "system",
          content: t
        },
        {
          role: "user",
          content: s
        }
      ],
      response_format: {
        type: "json_schema",
        json_schema: {
          name: "simple-prompt",
          schema: e,
          strict: !0
        }
      }
    }, n = await this.api.ticket.genericAIPrompt(o), r = (c = (u = (a = n == null ? void 0 : n.choices) == null ? void 0 : a[0]) == null ? void 0 : u.message) == null ? void 0 : c.content;
    if (r)
      return JSON.parse(r);
    throw new Error("Could not parse OpenAI response");
  }
  async completePrompt(e, t, s) {
    var a;
    const o = {
      model: "gpt-4o-2024-08-06",
      messages: t,
      tools: s != null && s.length ? s : void 0,
      response_format: {
        type: "json_schema",
        json_schema: {
          name: "complete-prompt",
          strict: !1,
          schema: e
        }
      },
      tool_choice: s != null && s.length ? "auto" : void 0,
      temperature: 1,
      top_p: 1,
      frequency_penalty: 0,
      presence_penalty: 0
    }, n = await this.api.ticket.genericAIPrompt(o), r = (a = n == null ? void 0 : n.choices) == null ? void 0 : a[0].message;
    if (r.content)
      return {
        message: JSON.parse(r.content)
      };
    if (r.tool_calls.length > 0)
      return {
        tools: r.tool_calls.map((u) => ({
          name: u.function.name,
          arguments: JSON.parse(u.function.arguments)
        }))
      };
    throw new Error("Could not parse OpenAI response");
  }
}
class ie extends T {
  constructor(e, t) {
    super(e, t);
  }
  async loadActivityTickets(e, t, s) {
    const o = await this.api.feed.fetchCreatedTickets(t, {
      size: s
    });
    return this.createTicketResponse(o.content, e, t);
  }
  async fetchTicketAssigneeAudience(e, t, s) {
    const o = E.query(e).filter("deleted", [!1]).filter("enabled", [!0]).build(), n = await this.api.ticket.fetchTicketAssigneeAudience(
      o,
      t,
      s
    ), r = x(n.result, (c) => c.id), u = (await this.datasource.user.listBatch(r)).filter((c) => c.enabled && !c.deleted).filter((c) => !!c.firstName || c.lastName);
    return this.addTeamToUsers(u);
  }
  async fetchTicketAssigneePermissions(e, t) {
    const s = E.query("--------").build();
    return (await this.api.ticket.fetchTicketAssigneeAudience(
      s,
      e,
      t
    )).permissions;
  }
  async loadTicketHistory(e, t, s) {
    const [o, n, r] = await Promise.all([
      this.datasource.ticket.find(t, s),
      this.datasource.workflow.find(t, e),
      this.api.ticket.getTicketHistory(t, s)
    ]);
    if (!o)
      return console.warn("Could not load history. Ticket not found"), [];
    if (!n)
      return console.warn("Could not load history. Workflow not found"), [];
    const a = x(r, (d) => d.creatorUser), u = await this.datasource.user.listBatch(a), c = y(u, (d) => d.id);
    return r.sort((d, p) => p.createdDate - d.createdDate).map((d) => ({
      ticket: o,
      workflow: n,
      history: d,
      user: c.get(d.creatorUser)
    }));
  }
  async loadChildTickets(e, t, s, o) {
    let { children: n } = await this.api.ticket.fetchChildTickets(
      t,
      s,
      o
    );
    const r = n.filter(
      ({ status: a }) => !["SCRATCH", "DRAFT", "ARCHIVED"].includes(a)
    );
    return this.createTicketResponse(r, e, t);
  }
  async loadTicketWalletTransactions(e) {
    const t = await this.api.juoco.fetchTicketWallet(e);
    if (t.length === 0) {
      console.warn(`Could not find ticket wallet [ticketId='${e}']`);
      return;
    }
    t.length > 1 && console.warn(
      `Multiple wallets found for ticket [ticketId='${e}']`
    );
    const s = t[0], n = (await this.api.juoco.getTicketTransactions(s.id)).extracts.sort(
      (u, c) => Date.parse(c.createdAt) - Date.parse(u.createdAt)
    ), r = x(
      n,
      (u) => u.foreignWalletId
    ), a = await this.api.juoco.fetchWalletOwners(r);
    return [s, n, a];
  }
  async loadPurchaseAudience(e) {
    let t = await this.api.ticket.fetchPurchaseAudience(e);
    t = t.filter((c) => c.includes("-"));
    const s = t.map(
      (c) => this.datasource.ticket.find(e, c)
    ), n = (await Promise.all(s)).filter((c) => c !== void 0);
    if (t.length !== n.length) {
      const c = t.length - n.length;
      console.warn(
        `Error loading purchase audience. ${c} tickets could not be loaded`
      );
    }
    const r = x(n, (c) => c.id), a = await this.api.juoco.fetchTicketWalletByBatch(r), u = [];
    return n.forEach((c) => {
      const d = a[c.id];
      d != null && d.length ? u.push([c, d[0]]) : console.warn(`Error loading Wallet of ticket=${c.id}]`);
    }), u;
  }
  async listMostActivePeople(e) {
    const s = (await this.datasource.user.listMostActive(e)).filter(
      (o) => o.firstName || o.lastName
    );
    return this.addTeamToUsers(s);
  }
  // ## Tasks
  async loadTasks(e, t, s, o) {
    let { children: n } = await this.api.ticket.fetchChildTickets(
      t,
      s,
      ["task"]
    );
    o && (n = n.filter((d) => {
      var p;
      return ((p = d.meta) == null ? void 0 : p.taskGroup) === o;
    }));
    const a = x(n, (d) => d.canonicalId).map((d) => this.getPublicComments(d)), u = await Promise.all(a), c = await this.createTicketResponse(
      n,
      e,
      t
    );
    return n.map((d, p) => {
      const f = c.find(
        ({ ticket: g }) => g.canonicalId === d.canonicalId
      ), m = u[p].sort((g, C) => C.createdAt - g.createdAt);
      return [f, m];
    });
  }
  async createTask(e, t, s, o) {
    const n = await this.api.ticket.getTicket(
      e,
      t
    ), r = {
      title: o,
      parent: t,
      type: "task",
      meta: {
        taskGroup: s || void 0
      }
    }, a = await this.api.ticket.createTicket(e, r), u = [...n.tasks, a];
    return await this.api.ticket.updateTasks(e, t, u), (await this.createTicketResponse(
      [a],
      a.context,
      e
    ))[0];
  }
  async removeTask(e, t) {
    await this.datasource.ticket.removeSubProduct(
      e,
      t,
      "task"
    );
  }
  async getTicketBadges(e) {
    return (await this.api.juoco.getVirtualGoodsFromPlayer(
      e,
      "BADGE",
      "TICKET"
    )).sort((s, o) => o.grantedAt - s.grantedAt);
  }
  async getMessages() {
    const e = await this.api.notifications.getMessages(), t = e.filter((s) => !s.deliveredAt).map(({ id: s }) => s);
    return t.length && this.api.notifications.markAsDeliveredBatch(t), e;
  }
  // ## Private Comments
  async getPrivateComments(e, t) {
    const s = await this.api.privateComment.fetchCommentsForTarget(
      e,
      t
    );
    return this.formatComments(s);
  }
  async createPublicComment(e, t) {
    const s = await this.api.comment.createComment(
      e,
      "TICKET",
      t
    );
    return (await this.formatComments([s]))[0];
  }
  // ## Comments
  async getPublicComments(e) {
    const t = await this.api.comment.fetchCommentsForTarget(e);
    return this.formatComments(t);
  }
  async formatComments(e) {
    const t = x(e, (n) => n.author), s = await this.findUsersById(t), o = y(s, (n) => n.user.id);
    return e.map((n) => {
      const r = o.get(n.author);
      return r || console.warn(`Could not find the comment author [id=${n.author}]`), {
        commentId: n.id,
        content: n.content,
        createdAt: n.createdAt,
        author: r
      };
    });
  }
}
class ce extends T {
  constructor(e, t) {
    super(e, t);
  }
  async filterByTags(e) {
    return this.datasource.topic.filterByTags(e);
  }
  async fetchTopicTags(e) {
    return this.api.topic.fetchTopicTags(e);
  }
  async fetchTopicByTag(e) {
    const t = await this.api.genericTags.fetchTargetsByTag(
      "topic",
      e
    );
    return this.datasource.topic.listBatch(t);
  }
  async createTopic(e) {
    const t = await this.datasource.topic.create(e.topicRequest);
    if (!(t != null && t.id))
      throw new Error("Could not create topic relations. TopicId not found");
    return this.topicRelationUpdate(
      t.id,
      e.ownerIds,
      e.teamIds
    );
  }
  async updateTopic(e) {
    const t = await this.datasource.topic.update(e.topicRequest);
    if (!(t != null && t.id))
      throw new Error("Could not update topic relations. TopicId not found");
    return this.topicRelationUpdate(
      t.id,
      e.ownerIds,
      e.teamIds
    );
  }
  async topicRelationUpdate(e, t, s) {
    await this.updateTopicVisibility(e, s);
    const o = await this.calculateTopicOwnerDifference(e, t);
    await this.updateTopicOwners(e, o);
  }
  async updateTopicVisibility(e, t) {
    const s = {
      topicId: e,
      teamsId: t
    };
    await this.api.topic.setTeamByTopic(s, "relates", !0);
  }
  async calculateTopicOwnerDifference(e, t) {
    if (!e)
      return [[], []];
    const s = await this.api.topic.fetchRelatedUsers(e, "expert"), o = t.filter((r) => !s.includes(r)), n = s.filter((r) => !t.includes(r));
    return [o, n];
  }
  async updateTopicOwners(e, t) {
    const s = t[0].map((n) => this.api.topic.setTopicUserRelationship(
      { topicId: e, userId: n },
      "expert"
    )), o = t[1].map((n) => this.api.topic.removeUserRelationship(
      { topicId: e, userId: n },
      "expert"
    ));
    await Promise.allSettled([...s, ...o]);
  }
  remove(e) {
    return this.datasource.topic.remove(e);
  }
}
class ue extends T {
  constructor(e, t) {
    super(e, t);
  }
  async getUser(e) {
    const t = await this.findUserById(e), s = await this.api.users.fetchUserRoles(e);
    if (!t)
      throw new Error(`Could not load User [id=${e}]`);
    return [t, s];
  }
  async createOffer(e, t, s, o) {
    const n = {
      price: t.price,
      group: t.group,
      stock: 99,
      virtualGood: {
        name: t.resources[o].title ?? "",
        type: "VOUCHER"
      },
      consumeUponPurchase: !1,
      resources: t.resources,
      visibilityTags: t.audience,
      workgroupId: t.workgroupId,
      tags: t.tags
    };
    return s ? this.api.providers.createOfferAsAdmin(e, n) : this.api.providers.createOffer(e, n);
  }
  async listUsers(e) {
    const t = await this.findUsersById(e), s = await this.api.users.fetchUserRolesByBatch(e), o = y(s, (r) => r.userId), n = [];
    return t.forEach((r) => {
      const a = o.get(r.user.id);
      a ? n.push([r, a]) : console.error(
        `Could not load Roles of User [userId=${r.user.id}]`
      );
    }), n.sort((r, a) => a[0].user.createdDate - r[0].user.createdDate);
  }
  async listOwnOffers() {
    const [e, t] = await Promise.all([
      this.api.providers.fetchOwnOffers(),
      this.listTeams(["WORKGROUP"])
    ]);
    return [e.sort(
      (o, n) => Date.parse(n.createdAt) - Date.parse(o.createdAt)
    ), t];
  }
  async listAllOffers() {
    const [e, t] = await Promise.all([
      this.api.providers.fetchOAllffers(),
      this.listTeams(["WORKGROUP"])
    ]);
    return [e.sort(
      (o, n) => Date.parse(n.createdAt) - Date.parse(o.createdAt)
    ), t];
  }
  async updateOffer(e, t, s, o) {
    const n = {
      id: t,
      price: s.price,
      group: s.group,
      consumeUponPurchase: !1,
      resources: s.resources,
      visibilityTags: s.audience,
      workgroupId: s.workgroupId,
      tags: s.tags
    };
    return o ? this.api.providers.updateOfferAsAdmin(
      e,
      t,
      n
    ) : this.api.providers.updateOffer(e, t, n);
  }
  async deleteOffer(e, t) {
    return this.api.providers.deleteOffer(e, t);
  }
  async deleteOfferAsAdmin(e) {
    return this.api.providers.deleteOfferAsAdmin(e);
  }
  async listOwnServiceOrders(e) {
    return (await this.api.providers.fetchServiceOrders(
      e
    )).sort((s, o) => o.createdDate - s.createdDate);
  }
  async listAllServiceOrders() {
    return (await this.api.providers.fetchAllServiceOrders()).sort((t, s) => s.createdDate - t.createdDate);
  }
}
class he extends R {
  constructor(t) {
    super(new k("id", 60));
    h(this, "api");
    this.api = t;
  }
  list(t) {
    return super.fetchMany(() => this.api.getAllCampaigns(t));
  }
  findById(t) {
    return super.findOne(
      t,
      () => this.api.getCampaignById(t)
    );
  }
  create(t) {
    return super.addOne(() => this.api.createCampaign(t));
  }
  remove(t) {
    return super.removeOne(
      t,
      () => this.api.deleteCampaign(t)
    );
  }
  update(t, s) {
    return super.updateOne(
      () => this.api.updateCampaign(t, s)
    );
  }
}
class de extends R {
  constructor(t) {
    super(new k("id", 60));
    h(this, "api");
    this.api = t;
  }
  listAvailable(t) {
    return super.fetchMany(() => this.api.fetchAvailableOffers(t));
  }
  find(t) {
    return super.findOne(t, () => this.api.getOfferById(t));
  }
}
class le extends R {
  constructor(t) {
    super(new k("parent", 60));
    h(this, "ticket");
    this.ticket = t;
  }
  async listBatch(t, s) {
    return super.findMany(s, async (o) => {
      const n = await this.ticket.fetchChildTicketsByBatch(
        t,
        o,
        "feedback",
        "first_citizen"
      );
      return Object.values(n);
    });
  }
}
class pe extends R {
  constructor(t) {
    super(new k("parent", 60));
    h(this, "ticket");
    this.ticket = t;
  }
  async listBatch(t, s) {
    return super.findMany(s, async (o) => {
      const n = await this.ticket.fetchChildTicketsByBatch(
        t,
        o,
        "feedback",
        "first_citizen",
        "admin"
      );
      return Object.values(n);
    });
  }
}
class me extends R {
  constructor(t) {
    super(new k("id", 60));
    h(this, "api");
    this.api = t;
  }
  list() {
    return super.fetchMany(() => this.api.getAllAgents());
  }
  find(t) {
    return super.findOne(t, () => this.api.fetchAgent(t));
  }
  create(t) {
    return super.addOne(() => this.api.saveOrUpdateAgent(t));
  }
  update(t) {
    return super.updateOne(() => this.api.saveOrUpdateAgent(t));
  }
  async delete(t) {
    return super.removeOne(t, () => this.api.deleteAgent(t));
  }
}
class fe extends T {
  constructor(e, t) {
    super(e, t);
  }
  async companyList() {
    return (await this.api.organizations.metaFetchAllOrganizations({
      size: 1e3
    })).content.sort((t, s) => s.createdDate - t.createdDate);
  }
  async companyDetails(e) {
    return this.api.organizations.metaFetchOrganizationByContext(e);
  }
  async createCompany(e) {
    return e.trial ? await this.api.organizations.metaCreateOrganizationTrial(e) : await this.api.organizations.metaCreateOrganization(e);
  }
  async userList(e, t) {
    const s = await this.api.users.metaUserSearch(e, {
      query: `${t}*`
    }), o = await this.api.users.metaFetchByBatch(e, s);
    if (!s)
      throw new Error(`Could not search Users [context=${e}]`);
    if (!o)
      throw new Error(
        `Could not fetch Users by Batch [context=${e}]`
      );
    return o;
  }
  async userDetails(e, t) {
    const s = await this.api.users.metaGetUser(t, e), o = await this.api.role.metaFetchRolesByUser(
      e,
      t
    );
    if (!s)
      throw new Error(`Could not load User [id=${t}]`);
    if (!o)
      throw new Error(
        `Could not load Roles for [user=${t}, context=${e}]`
      );
    return [s, o];
  }
}
class G extends T {
  constructor(t, s) {
    super(t, s);
    h(this, "getOrganizationTransactionsAllWallet");
    h(this, "getOrganizationWalletsDetailsBatch");
    h(this, "getOrganizationWallets_");
    h(this, "getOrganizationTransactionsByWallet");
  }
  formatPrice(t) {
    return new Intl.NumberFormat(void 0, {
      style: "decimal",
      signDisplay: "exceptZero",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(t);
  }
  formatTransactions(t) {
    return t.map((s) => ({
      ...s,
      date: new Date(s.createdAt).toLocaleDateString(),
      amount: this.formatPrice(s.value)
    }));
  }
  async allCreditDetails(t) {
    const s = await this.getOrganizationTransactionsAllWallet(
      t
    );
    return this.creditDetailsByWalletId(s, t);
  }
  async creditDetails(t) {
    let s;
    const o = await this.api.juoco.fetchCompanyWallet(
      t
    );
    if ((o == null ? void 0 : o.length) != 1)
      throw new Error(
        `Could not load company wallets [context=${t}]`
      );
    s = o[0];
    const n = await this.getOrganizationTransactionsByWallet(
      s.id,
      t
    );
    return this.creditDetailsByWalletId(
      n,
      t,
      s.id
    );
  }
  generateTransactionsExtract(t, s) {
    return t.map((o) => ({
      transaction: o,
      walletFrom: s == null ? void 0 : s.get(o.walletId),
      walletTo: o.foreignWalletId ? s == null ? void 0 : s.get(o.foreignWalletId) : void 0
    }));
  }
  async creditDetailsByWalletId(t, s, o) {
    const n = this.formatTransactions(t.extracts), r = await this.getWalletIdsDetails(
      n,
      s,
      o
    ), a = this.generateTransactionsExtract(
      n,
      r
    );
    return {
      walletDetails: o ? r.get(o) : void 0,
      extract: a
    };
  }
  getTransactionsWalletIds(t) {
    const s = t.map((r) => r.walletId), o = t.map((r) => r.foreignWalletId).filter((r) => !!r), n = s.concat(o);
    return O(n);
  }
  async getWalletIdsDetails(t, s, o) {
    const n = this.getTransactionsWalletIds(t);
    o && n.push(o);
    const r = await this.getOrganizationWalletsDetailsBatch(n, s), a = /* @__PURE__ */ new Map();
    return Object.entries(r).forEach(([u, c]) => {
      a.set(u, c);
    }), a;
  }
  getFormattedWallets(t) {
    return t.filter((s) => s.type === "TICKET" || s.type === "SPONSOR").filter((s) => s.balance !== 0);
  }
  async getOrganizationWallets(t) {
    const s = await this.getOrganizationWallets_(t), o = this.getFormattedWallets(s), n = o.map((a) => a.id), r = await this.getOrganizationWalletsDetailsBatch(
      n,
      t
    );
    return o.map((a) => {
      var u;
      return {
        ...a,
        name: ((u = r[a.id].owner) == null ? void 0 : u.firstName) || ""
      };
    });
  }
}
class ge extends G {
  constructor(e, t) {
    super(e, t), this.getOrganizationTransactionsAllWallet = (s) => this.api.juoco.getMetaOrganizationTransactionsAllWallet(
      s
    ), this.getOrganizationWalletsDetailsBatch = (s, o) => this.api.juoco.getMetaOrganizationWalletsDetailsBatch(
      o,
      s
    ), this.getOrganizationWallets_ = (s) => this.api.juoco.getMetaOrganizationWallets(s), this.getOrganizationTransactionsByWallet = (s, o) => this.api.juoco.getMetaOrganizationTransactionsByWallet(
      o,
      s
    );
  }
}
class Te extends G {
  constructor(e, t) {
    super(e, t), this.getOrganizationTransactionsAllWallet = () => this.api.juoco.getAdminOrganizationTransactionsAllWallet(), this.getOrganizationWalletsDetailsBatch = (s) => this.api.juoco.getAdminOrganizationWalletsDetailsBatch(s), this.getOrganizationWallets_ = () => this.api.juoco.getAdminOrganizationWallets(), this.getOrganizationTransactionsByWallet = (s) => this.api.juoco.getAdminOrganizationTransactionsByWallet(s);
  }
}
class ye extends T {
  constructor(t, s, o) {
    super(t, s);
    h(this, "feedback");
    this.feedback = o;
  }
  async quickSearch(t) {
    const { query: s, filter: o } = t, n = E.query(s).filter("type", o == null ? void 0 : o.excludeTicketTypes, "NOT_EQUAL").build(), r = await this.api.search.quickSearch(n);
    return {
      ticketIds: r.tickets ?? [],
      userIds: r.users ?? []
    };
  }
  async searchTicketIdsGrouped(t, s) {
    const n = F(t, s).map((a) => this.searchTicketIds(a));
    return (await Promise.all(n)).flat();
  }
  async searchTicketIdsGroupedExtended(t, s) {
    const n = F(t, s).map((a) => this.searchTicketIdsExtended(a));
    return (await Promise.all(n)).flat();
  }
  buildTicketSearchRequest(t) {
    const { query: s, filter: o, sort: n, limit: r } = t, a = (o == null ? void 0 : o.fromDate) || (/* @__PURE__ */ new Date(0)).toISOString(), u = (o == null ? void 0 : o.toDate) || (/* @__PURE__ */ new Date()).toISOString(), c = [a, u];
    return E.query(s).filter("type.keyword", o == null ? void 0 : o.type).filter("status.keyword", o == null ? void 0 : o.status).filter("phase.keyword", o == null ? void 0 : o.phases).filter("creatorId.keyword", o == null ? void 0 : o.creator).filter("assignee.id.keyword", o == null ? void 0 : o.assignee).filter("delegates.id.keyword", o == null ? void 0 : o.team).filter("delegates.id.keyword", o == null ? void 0 : o.topic).filter("skills.keyword", o == null ? void 0 : o.skills).filter("genericTags.keyword", o == null ? void 0 : o.tags).filter(
      "meta.campaignProductRestriction.keyword",
      o != null && o.campaignProductRestriction ? [o.campaignProductRestriction] : void 0
    ).filter("parent.keyword", o != null && o.parent ? [o.parent] : void 0).filter("createdDate", c, "BETWEEN").sort(n).limit(r).build();
  }
  async searchTicketIds(t) {
    const s = this.buildTicketSearchRequest(t);
    return this.api.search.ticketSearch(s);
  }
  // it is the same as the one above but searchTicketIds will need a refactor
  // to remove what it is not need it
  async searchTicketIdsExtended(t) {
    const s = this.buildTicketSearchRequest(t);
    return this.api.search.ticketAttachmentSearch(s);
  }
  async searchUserIds(t) {
    const { context: s, query: o, filter: n, sort: r, limit: a } = t;
    let u = E.query(o).filter("unit.keyword", n == null ? void 0 : n.unit).filter("skills.keyword", n == null ? void 0 : n.skills).filter("language.keyword", n == null ? void 0 : n.language).contextFilter(s, "teamIds.{{context}}.keyword", n == null ? void 0 : n.teams).contextFilter(s, "teamIds.{{context}}.keyword", n == null ? void 0 : n.workgroups).contextFilter(
      s,
      "teamIds.{{context}}.keyword",
      n == null ? void 0 : n.virtualTeams
    ).contextFilter(s, "topicIds.{{context}}.keyword", n == null ? void 0 : n.topics).filter("deleted", [!1]).filter("enabled", [!0]).sort(r);
    n != null && n.active && (u = u.filter(
      "lastActiveDate",
      void 0,
      "EXISTS"
    ));
    const c = u.limit(a).build();
    return this.api.search.userSearch(c);
  }
  // Not implemented in the BE yet
  teamLocalQuery(t, s, o) {
    if (!t)
      return s;
    const n = t.toUpperCase();
    return s.filter((r) => {
      var c;
      const a = r.resources ?? {};
      return (((c = o(a)) == null ? void 0 : c.name) || r.name).toUpperCase().includes(n);
    });
  }
  async searchTeamIds(t, s) {
    const { query: o, filter: n, sort: r, limit: a } = t;
    r && Object.keys(r).length === 0 && console.warn("Sorting teams not implemented, using default order");
    const u = await this.datasource.team.list(n == null ? void 0 : n.type);
    let c = this.teamLocalQuery(o, u, s);
    if (n != null && n.tags) {
      const d = await this.api.genericTags.fetchTargetsByTag(
        "team",
        n.tags
      ), p = Object.values(d).flat();
      c = c.filter((f) => p.includes(f.id));
    }
    return c.slice(0, a).map((d) => d.id);
  }
  async status(t, s, o = "app") {
    var a, u, c, d, p;
    const n = await this.datasource.workflow.find(s, t), r = ((p = (d = (c = (u = (a = n == null ? void 0 : n.site) == null ? void 0 : a[o]) == null ? void 0 : u.views) == null ? void 0 : c.GlobalSearch) == null ? void 0 : d.filters) == null ? void 0 : p.status) ?? [];
    return r.length === 0 && console.error(
      `Could not load status list, '${o}.views.GlobalSearch' not found.`
    ), [r, n];
  }
  async phases(t, s, o = "app") {
    var a, u, c;
    const n = await this.datasource.workflow.find(s, t);
    return [((c = (u = (a = n == null ? void 0 : n.site) == null ? void 0 : a[o]) == null ? void 0 : u.views) == null ? void 0 : c.GlobalSearch.filters.phases) ?? [], n];
  }
  skill() {
    return this.api.skills.fetchSkillCatalog(!1);
  }
  tags() {
    return this.api.genericTags.fetchGenericTagsCatalog("tag");
  }
}
class Ce extends T {
  constructor(t, s, o) {
    super(t, s);
    h(this, "ticket");
    this.ticket = o;
  }
  async loadPopularTickets(t, s, o) {
    const n = await this.api.feed.fetchPopularTickets(t, {
      size: o
    });
    return this.createTicketResponse(n.content, s, t);
  }
  async loadTopCommenters(t, s) {
    const o = await this.api.feed.fetchTopCommenters(t, { size: s }), n = x(o.content, (c) => c.userId), r = await this.datasource.user.listBatch(n), a = y(r, (c) => c.id), u = [];
    return o.content.forEach((c) => {
      const d = a.get(c.userId);
      d ? u.push({ user: d, activityCount: c.activityCount }) : console.warn(`Could not find user [id=${c.userId}]`);
    }), u;
  }
  async loadTopReactors(t, s) {
    const o = await this.api.feed.fetchTopReactors(t, { size: s }), n = x(o.content, (c) => c.userId), r = await this.datasource.user.listBatch(n), a = y(r, (c) => c.id), u = [];
    return o.content.forEach((c) => {
      const d = a.get(c.userId);
      d ? u.push({ user: d, activityCount: c.activityCount }) : console.warn(`Could not find user [id=${c.userId}]`);
    }), u;
  }
  async loadActivityFeed(t, s) {
    const o = await this.api.feed.fetchActivityFeed(t, { size: s });
    return (await Promise.all(
      o.content.map(async (r) => {
        const a = this.resolveEventType(r);
        switch (a) {
          case "status-updated":
            return this.loadActivityStatusUpdated(r);
          case "comment-added":
            return this.loadActivityCommentAdded(r);
          case "offer-purchased":
            return this.loadActivityOfferPurchased(r);
          case "feedback-created":
            return this.loadActivityFeedbackCreated(r);
          case "ignored":
            return;
          default:
            console.warn(`Unknown event type: '${a}'`);
            return;
        }
      })
    )).filter(Boolean);
  }
  matchEntry(t, s) {
    for (const o of s)
      if (this.match(t, o))
        return !0;
    return !1;
  }
  match(t, s) {
    var n, r;
    const o = (r = (n = t.meta.ticketId) == null ? void 0 : n.split("-")) == null ? void 0 : r[1];
    return Object.entries(s).every(
      ([a, u]) => !u || u === "*" || (a == "ticketType" ? u === o : u === t[a])
    );
  }
  resolveEventType(t) {
    const s = {
      "comment-added": [
        {
          category: "ticket",
          type: "comment",
          action: "add"
        }
      ],
      "offer-purchased": [
        {
          category: "transaction",
          type: "offer",
          action: "purchase"
        }
      ],
      "feedback-created": [
        {
          category: "ticket",
          type: "status",
          action: "change",
          ticketType: "feedback"
        }
      ],
      "status-updated": [
        {
          category: "ticket",
          type: "status",
          action: "change"
        }
      ],
      ignored: [
        {
          category: "*",
          type: "*",
          action: "*"
        }
      ]
    };
    return Object.keys(s).find(
      (r) => this.matchEntry(t, s[r])
    ) ?? "ignored";
  }
  async loadActivityStatusUpdated(t) {
    try {
      if (t.meta.parent)
        return;
      const [s, o] = await Promise.all([
        this.ticket.loadTicket(
          t.context,
          t.product,
          t.meta.ticketId
        ),
        this.datasource.user.findById(t.userId)
      ]);
      if (!s) {
        console.warn(
          "Could not load ticketResponse while executing loadActivityStatusUpdated"
        );
        return;
      }
      if (!o) {
        console.warn(
          "Could not load user while executing loadActivityStatusUpdated"
        );
        return;
      }
      return ["status-updated", t, s, o];
    } catch (s) {
      console.error("Error loading activity feed entry", s);
      return;
    }
  }
  async loadActivityCommentAdded(t) {
    try {
      const [s, o] = await Promise.all([
        this.ticket.loadTicket(
          t.context,
          t.product,
          t.meta.ticketId
        ),
        this.datasource.user.findById(t.userId)
      ]);
      if (!s) {
        console.warn(
          "Could not load ticket while executing loadActivityCommentAdded"
        );
        return;
      }
      if (!o) {
        console.warn(
          "Could not load user while executing loadActivityCommentAdded"
        );
        return;
      }
      return ["comment-added", t, s, o];
    } catch (s) {
      console.error("Error loading activity feed entry", s);
      return;
    }
  }
  async loadActivityOfferPurchased(t) {
    try {
      const [s, o, n] = await Promise.all([
        this.datasource.offer.find(t.meta.offerId),
        this.datasource.ticket.find(t.product, t.meta.serviceOrderId),
        this.datasource.user.findById(t.userId)
      ]);
      if (!s) {
        console.warn(
          "Could not load offer while executing loadActivityOfferPurchased"
        );
        return;
      }
      if (!o) {
        console.warn(
          "Could not load ticket while executing loadActivityOfferPurchased"
        );
        return;
      }
      if (!n) {
        console.warn(
          "Could not load user while executing loadActivityOfferPurchased"
        );
        return;
      }
      const r = await this.datasource.team.find(
        s.workgroupId,
        "serviceProvider"
      );
      if (!r) {
        console.warn(
          "Could not load workgroup while executing loadActivityOfferPurchased"
        );
        return;
      }
      return ["offer-purchased", t, s, r, o, n];
    } catch (s) {
      console.error("Error loading activity feed entry", s);
      return;
    }
  }
  async loadActivityFeedbackCreated(t) {
    try {
      if (!t.meta.parent) {
        console.warn(
          "No parent ticket information while executing loadActivityFeedbackCreated"
        );
        return;
      }
      const [s, o, n] = await Promise.all([
        this.datasource.ticket.find(t.product, t.meta.parent),
        this.datasource.ticket.find(t.product, t.meta.ticketId),
        this.datasource.user.findById(t.userId)
      ]);
      if (!s) {
        console.warn(
          "Could not load parent while executing loadActivityFeedbackCreated"
        );
        return;
      }
      if (!o) {
        console.warn(
          "Could not load ticket while executing loadActivityFeedbackCreated"
        );
        return;
      }
      if (!n) {
        console.warn(
          "Could not load user while executing loadActivityFeedbackCreated"
        );
        return;
      }
      return ["feedback-created", t, s, o, n];
    } catch (s) {
      console.error("Error loading activity feed entry", s);
      return;
    }
  }
}
class j extends T {
  constructor(e, t) {
    super(e, t);
  }
  async isFeedbackAllowed(e, t) {
    var n, r;
    if (e.allowFeedback !== !1 && (!((n = e.meta) != null && n.restrictReplyAudience) || [e.creator, e.assignee].includes(t)))
      return !0;
    const o = (await this.datasource.team.fetchSubscribedTeams(t)).map(({ id: a }) => a);
    return ((r = e.delegate) == null ? void 0 : r.filter(({ domain: a }) => a === "team").some(({ id: a }) => o.includes(a))) ?? !1;
  }
  async fetchDefaultFeedbackTickets(e, t) {
    const [s, o] = await Promise.all([
      this.datasource.workflow.find("feedback", e),
      this.datasource.workflow.find(t, e)
    ]), n = (s == null ? void 0 : s.settings.defaultTicket) ?? {};
    return Object.entries(n).filter(
      ([r]) => {
        var a;
        return !!((a = o == null ? void 0 : o.settings.enabledFeedbackTypes) != null && a.includes(
          r
        ));
      }
    ).map(([, r]) => this.convertToFeedbackTicket(r));
  }
  async loadFeedbackTickets(e, t) {
    const { children: s } = await this.api.ticket.fetchChildTickets(
      e,
      t,
      ["feedback"]
    );
    return s.filter((o) => o.status !== "ARCHIVED").map((o) => this.convertToFeedbackTicket(o));
  }
  async loadFeedbackTicketById(e, t) {
    const s = await this.api.ticket.getTicket(e, t);
    return this.convertToFeedbackTicket(s);
  }
  async saveFeedbackTicket(e, t) {
    const { title: s, parentTicketId: o, text: n, type: r, product: a, delegate: u, languages: c } = e, d = c.reduce((m, g) => (m[g] = {
      title: s,
      text: (
        // Need to escape chars with JSON.stringify, but remove the surrounding quotes
        JSON.stringify(n).slice(1, -1)
      )
    }, m), {}), p = {
      title: s,
      parent: o,
      meta: {
        title: s,
        text: n,
        "feedback-type": r
      },
      delegate: u,
      resources: d,
      type: "feedback"
    };
    let f;
    return t ? f = await this.api.ticket.updateTicket(
      a,
      t,
      p
    ) : (f = await this.api.ticket.createTicket(a, p), f = await this.api.ticket.updateTicketStatus(
      a,
      f.canonicalId,
      "IN_PROGRESS"
    )), this.convertToFeedbackTicket(f);
  }
  convertToFeedbackTicket(e) {
    return {
      ...e,
      meta: {
        ...e.meta,
        // BE returns a string...
        allowResubmission: e.meta.allowResubmission === "true",
        allowDelete: e.meta.allowDelete !== "false",
        // Default: true
        allowEdit: e.meta.allowEdit !== "false",
        // Default: true
        feedbackDialogue: this.parseFeedbackDialogue(
          e.meta.feedback,
          e.resources,
          e.canonicalId,
          e.group,
          e.audience
        ),
        feedbackFieldContent: e.meta.feedbackFieldContent ? JSON.parse(e.meta.feedbackFieldContent) : []
      },
      allowFeedback: e.status === "IN_PROGRESS"
    };
  }
  parseFeedbackDialogue(e, t = {}, s, o, n) {
    try {
      const r = JSON.parse(e).dialog, a = Object.keys(t ?? {});
      return a.length > 0 && Object.keys(r).forEach((c) => {
        const d = a.includes(c) ? c : "en";
        r[d] = {
          ...r[d],
          ...t[d],
          ticketId: s,
          group: o,
          audience: n
        };
      }), r;
    } catch (r) {
      return console.error("Error parsing feedback dialogue", s, r), {};
    }
  }
}
class Ae extends T {
  constructor(e, t) {
    super(e, t);
  }
  async loadAvailableOffers(e) {
    const t = await this.datasource.offer.listAvailable(e);
    return this.createOfferResponse(t);
  }
  async loadOfferDetails(e) {
    const t = await this.datasource.offer.find(e);
    if (!t)
      throw new Error(`Could not find offer [id=${e}]`);
    const s = await this.createOfferResponse([t]);
    if (s.length === 1)
      return s[0];
    throw new Error(`Error loading offer [offerId=${e}]`);
  }
  async createOfferResponse(e) {
    const t = x(e, (r) => r.workgroupId), s = await this.datasource.team.listBatch(
      t,
      "serviceProvider"
    ), o = y(s, (r) => r.id), n = [];
    return e.forEach((r) => {
      const a = o.get(r.workgroupId);
      a ? n.push([r, a]) : console.warn(
        `Could not find workgroup [workgroupId=${r.workgroupId}]`
      );
    }), n;
  }
}
class we extends T {
  constructor(t, s, o, n) {
    super(t, s);
    h(this, "search");
    h(this, "ticket");
    this.search = o, this.ticket = n;
  }
  async loadCampaignOverview(t, s, o, n = 0) {
    const r = await this.searchCampaigns(o, n);
    return this.ticket.loadTicketsByBatch(t, s, r);
  }
  async loadCampaignSpotlights(t, s, o, n) {
    const r = await this.datasource.workflow.find("campaign", t);
    if (!r)
      return [];
    const a = {
      query: "",
      type: ["campaign"],
      status: o,
      productRestriction: n
    }, u = await this.searchCampaigns(a, 5), c = this.datasource.ticket.listBatch(
      t,
      "campaign",
      u
    ), d = u.reduce(async (C, b) => {
      const A = await C;
      return A[b] = (await this.api.watcher.fetchWatcherForTarget(b, "TICKET")).length, A;
    }, {}), p = u.reduce(async (C, b) => {
      const A = await C;
      return A[b] = (await this.api.ticket.fetchChildTickets(s, b)).children.filter(
        (q) => !["SCRATCH", "DRAFT", "ARCHIVED"].includes(q.status)
      ).filter(
        (q) => !["feedback", "task", "service_order"].includes(q.type)
      ).length, A;
    }, {}), [f, m, g] = await Promise.all([
      c,
      d,
      p
    ]);
    return f.map(
      (C) => ({
        ticket: C,
        workflow: r,
        watchers: m[C.canonicalId] ?? 0,
        childTickets: g[C.canonicalId] ?? 0
      })
    );
  }
  async searchCampaigns(t, s) {
    const o = this.getProductRestrictionFilter(
      t.productRestriction
    ), n = E.query(t.query).filter("type.keyword", ["campaign"]).filter("status.keyword", t.status).filter(
      "meta.campaignProductRestriction.keyword",
      o
    ).limit(s).build();
    return this.api.search.ticketSearch(n);
  }
  getProductRestrictionFilter(t) {
    return t && !t.includes("*") ? t : void 0;
  }
}
class ke extends T {
  constructor(e, t) {
    super(e, t);
  }
  async runningChallengeList(e) {
    return this.filterJoinedChallenges("PENDING", e);
  }
  async completedChallengeList(e) {
    return this.filterJoinedChallenges("SUCCESS", e);
  }
  async metaChallengeList(e) {
    return (await this.api.juoco.metaFetchChallengesByContext(
      e
    )).map((s) => s.challenge);
  }
  async adminChallengeList() {
    return this.api.juoco.adminFetchChallenges();
  }
  async filterJoinedChallenges(e, t) {
    return (await this.api.juoco.getJoinedChallenges()).filter(({ playerChallenge: { status: o, challenge: n } }) => {
      var u, c;
      const r = o === e;
      let a = !0;
      return t && n.filter && (a = ((c = (u = n.filter) == null ? void 0 : u.match(/in \['(.*?)',\s?'all'\]/)) == null ? void 0 : c[1]) === t), r && a;
    }).map(({ playerChallenge: o, challenge: n }) => ({
      ...o,
      challenge: n
    }));
  }
}
class Re extends T {
  constructor(e, t) {
    super(e, t);
  }
  async loadDigitalContentList(e, t, s = "") {
    let o;
    if (s)
      o = await this.api.digitalContent.fetchSectionItems(
        e,
        t,
        s,
        { status: "PUBLISHED" }
      );
    else {
      const n = await this.api.digitalContent.fetchGallery(
        e,
        t,
        { status: "PUBLISHED" }
      );
      o = Object.values(n).flatMap(
        (r) => r
      );
    }
    return o.sort((n, r) => n.weight - r.weight);
  }
}
class xe extends T {
  constructor(t, s, o, n) {
    super(t, s);
    h(this, "search");
    h(this, "ai");
    this.search = o, this.ai = n;
  }
  async createScratchTicket(t, s, o) {
    var c;
    const [n, r] = await Promise.all([
      this.api.workflow.fetchWorkflow(s),
      this.datasource.dynamicField.find(s, t)
    ]), a = n.settings.creationStatus;
    return [await this.api.ticket.createTicket(s, {
      status: a,
      type: (c = n.product) == null ? void 0 : c.ticketType,
      parent: o,
      meta: {},
      delegate: [],
      files: [],
      skills: []
    }), n, r];
  }
  async loadTicket(t, s, o, n = !0) {
    const r = await (n ? this.datasource.ticket.find(s, o) : this.api.ticket.getTicket(s, o)), a = r ? [r] : [];
    return (await this.createTicketResponse(
      a,
      t,
      s
    ))[0];
  }
  async loadTicketsByBatch(t, s, o) {
    const n = await this.datasource.ticket.listBatch(
      t,
      s,
      o
    );
    return n.length ? await this.createTicketResponse(n, t, s) : [];
  }
  async suggestTicketTitles(t, s, o) {
    var m;
    const [n, r] = await Promise.all([
      this.api.skills.fetchSkillsFromOtherUser(t),
      // this.api.organizations.fetchCurrentOrganization(contextId),
      this.datasource.ticket.find("campaign", o)
    ]), a = 6, u = (m = r == null ? void 0 : r.meta) == null ? void 0 : m.description, c = n.join(","), d = `I am a creative idea generator for ${s}`, p = `
    I want employees to create new ideas that might help the organization, using the organization business to help them.
    To help inspiring the user, create a list of ${a} suggestions composed of title and description for suitable and practical ideas that are in line with and would help improving the situation described by the following text: ${u}.
    Tailored, but not limited to the following skills: ${c}`, f = {
      type: "object",
      properties: {
        fields: {
          type: "array",
          items: {
            type: "object",
            properties: {
              title: { type: "string" },
              description: { type: "string" }
            },
            required: ["title", "description"],
            additionalProperties: !1
          }
        }
      },
      required: ["fields"],
      additionalProperties: !1
    };
    return this.ai.simplePrompt(
      f,
      d,
      p
    );
  }
  async similarityBetweenTickets(t, s, o, n) {
    function r(g, C) {
      return g.replace(/{{(.*?)}}/g, (b, A) => C[A.trim()] || "");
    }
    const [a, u] = await Promise.all([
      this.api.genericTags.fetchGenericTags("tag", t.canonicalId),
      this.api.genericTags.fetchGenericTags("tag", s.canonicalId)
    ]), c = JSON.stringify({
      title: t.title,
      ...t.meta,
      tags: a.join(", ")
    }), d = JSON.stringify({
      title: s.title,
      ...s.meta,
      tags: u.join(", ")
    });
    let p = r(n.prompt.text, {
      ticketA: c,
      ticketB: d
    });
    o && n.prompt.promptForUserLanguage && (p = p.concat(
      `, and please reply it in the language ${o}`
    ));
    const f = {
      type: "object",
      properties: {
        similarities: {
          type: "array",
          items: {
            type: "object",
            properties: {
              title: {
                type: "string"
              },
              description: {
                type: "string"
              }
            },
            required: ["title", "description"],
            additionalProperties: !1
          }
        }
      },
      required: ["similarities"],
      additionalProperties: !1
    };
    return (await this.ai.simplePrompt(
      f,
      "",
      p
    )).similarities;
  }
}
class $e extends T {
  constructor(e, t) {
    super(e, t);
  }
  async removeTeamMembers({
    userIds: e,
    teamId: t,
    role: s
  }) {
    const o = e.map((r) => this.api.team.removeTeamMember({
      teamId: t,
      userId: r,
      role: s
    }));
    if ((await Promise.allSettled(o)).some((r) => r.status === "rejected"))
      throw new Error("Could not remove all team members");
  }
  async fetchTeamByTag(e, t) {
    const s = await this.api.genericTags.fetchTargetsByTag("team", e);
    return this.datasource.team.listBatch(s, t);
  }
  async updateTeamMembers({
    teamId: e,
    userIds: t,
    role: s,
    teamType: o
  }) {
    const r = (await this.api.team.fetchTeamMembers(e)).filter((m) => m.roles.includes(s)).map((m) => m.userId), a = t, u = a.filter((m) => !r.includes(m)), c = r.filter((m) => !a.includes(m)), d = u.map((m) => {
      const g = { teamId: e, userId: m, role: s };
      switch (o) {
        case "COCREATORS":
          return this.api.team.addCoCreator(g);
        case "VIRTUAL_TEAM":
          return this.api.team.addTeamMember(g);
        default:
          return this.api.team.addTeamMemberAsAdmin(g);
      }
    }), p = c.map((m) => {
      const g = { teamId: e, userId: m, role: s };
      switch (o) {
        case "COCREATORS":
          return this.api.team.removeCoCreator(g);
        case "VIRTUAL_TEAM":
          return this.api.team.removeTeamMember(g);
        default:
          return this.api.team.removeTeamMemberAsAdmin(g);
      }
    });
    if ((await Promise.allSettled([
      ...d,
      ...p
    ])).some((m) => m.status === "rejected"))
      throw new Error("Could not update all team members");
  }
  async updateTeam(e) {
    const t = await this.datasource.team.update({
      id: e.team.id ?? "",
      context: "",
      createdBy: e.team.createdBy ?? "",
      description: e.team.description,
      name: e.team.name,
      type: e.team.type
    });
    if (!t) {
      console.warn(`Could not create team: '${e.team.name}'`);
      return;
    }
    return await this._updateTeamMembers(e, t.id), t;
  }
  async createTeam(e) {
    const t = await this.datasource.team.create({
      id: "",
      context: "",
      createdBy: e.team.createdBy ?? "",
      description: e.team.description,
      name: e.team.name,
      type: e.team.type
    });
    if (!t) {
      console.warn(`Could not create team: '${e.team.name}'`);
      return;
    }
    return await this._updateTeamMembers(e, t.id), t;
  }
  async _updateTeamMembers(e, t) {
    await Promise.allSettled(
      e.actions.map(({ userId: s, role: o, action: n }) => n === "add" ? this.api.team.addTeamMember({
        teamId: t,
        userId: s,
        role: o
      }) : n === "remove" ? this.api.team.removeTeamMember({
        teamId: t,
        userId: s,
        role: o
      }) : (console.warn(`Unknown team member action: '${n}'`), Promise.reject()))
    );
  }
}
const qe = {
  install(i, e) {
    const t = new _t(e), s = {
      authentication: new et(t),
      users: new Ot(t),
      juoco: new pt(t),
      search: new lt(t),
      workflow: new qt(t),
      dynamicFields: new nt(t),
      dynamicInformation: new rt(t),
      providers: new kt(t),
      organizations: new yt(t),
      digitalContent: new wt(t),
      email: new at(t),
      mailCoaching: new Rt(t),
      notifications: new gt(t),
      role: new At(t),
      skills: new vt(t),
      team: new $t(t),
      topic: new Et(t),
      stats: new xt(t),
      ticket: new bt(t),
      comment: new st(t),
      privateComment: new ot(t),
      reaction: new Ct(t),
      event: new it(t),
      feed: new ut(t),
      fileUpload: new ht(t),
      fileAttachment: new dt(t),
      activeDirectory: new St(t),
      tags: new Pt(t),
      watcher: new Bt(t),
      dashboard: new Dt(t),
      link: new ft(t),
      similaritySearch: new Gt(t),
      genericTags: new Ut(t),
      ticketFileUpload: new It(t),
      organizationAiSettings: new Ft(t),
      aiAgent: new jt(t),
      kafka: new zt(t),
      eventCollector: new Mt(t)
    }, o = {
      user: new oe(s.users, s.feed),
      mailCoaching: new he(s.mailCoaching),
      offer: new de(s.juoco),
      dynamicField: new Xt(s.dynamicFields),
      aiAgent: new me(s.aiAgent),
      workflow: new ne(s.workflow),
      team: new Yt(s.team),
      topic: new se(s.topic, s.feed),
      ticket: new te(s.ticket),
      ticketWallet: new ee(s.juoco),
      reaction: new Zt(s.reaction),
      firstCitizen: new le(s.ticket),
      adminFirstCitizen: new pe(s.ticket)
    }, n = new ae(s, o), r = new j(s, o), a = new ye(s, o, r), u = new xe(
      s,
      o,
      a,
      n
    ), c = {
      search: a,
      portal: new ie(s, o),
      serviceProvider: new ue(s, o),
      admin: new re(s, o),
      meta: new fe(s, o),
      wallet: new G(s, o),
      // need it?
      metaWallet: new ge(s, o),
      adminWallet: new Te(s, o),
      activity: new Ce(s, o, u),
      feedback: new j(s, o),
      team: new $e(s, o),
      topic: new ce(s, o),
      offer: new Ae(s, o),
      campaign: new we(s, o, a, u),
      ticket: u,
      challenge: new ke(s, o),
      digitalContent: new Re(s, o),
      ai: n
    };
    i.prototype.$api = s, i.prototype.$datasource = o, i.prototype.$gateway = c;
  }
};
export {
  St as ActiveDirectoryApi,
  jt as AiAgentApi,
  et as AuthenticationApi,
  st as CommentApi,
  Tt as ContentType,
  Dt as DashboardApi,
  wt as DigitalContentApi,
  nt as DynamicFieldsApi,
  rt as DynamicInformationApi,
  at as EmailApi,
  ct as EventAction,
  it as EventApi,
  Mt as EventCollectorApi,
  ut as FeedApi,
  dt as FileAttachmentApi,
  ht as FileUploadApi,
  Ut as GenericTagsApi,
  lt as GlobalSearchApi,
  Oe as IAiSettingKeys,
  pt as JuocoApi,
  zt as KafkaApi,
  ft as LinkApi,
  Rt as MailCoachingApi,
  gt as NotificationApi,
  Ft as OrganizationAiSettingsApi,
  yt as OrganizationsApi,
  ot as PrivateCommentApi,
  kt as ProvidersApi,
  Ct as ReactionApi,
  At as RoleApi,
  _t as SdkClient,
  qe as SdkPluginVue2,
  E as SearchBuilder,
  Gt as SimilaritySearchApi,
  vt as SkillsApi,
  xt as StatsApi,
  Pt as TagsApi,
  $t as TeamApi,
  bt as TicketApi,
  It as TicketFileUploadApi,
  Et as TopicApi,
  mt as TransactionType,
  Ot as UsersApi,
  Bt as WatcherApi,
  qt as WorkflowApi,
  F as buildGroupSearch,
  O as distinctItems,
  x as distinctValues,
  Nt as getDeepValue,
  Ee as groupBy,
  y as mapBy,
  Vt as useMustache
};
